<template>
  <div
    id="timeline-list-container"
    v-on:mousedown="$_onMousedown"
  >
    <resizable-frame
      right
      ref="timelineTitleAndFooterContainer"
      v-bind:width-px.sync="$_timelineTitleWidthPx"
      v-bind:width-px-min="$_timelineTitleWidthPxMin"
      v-bind:width-px-max="$_timelineTitleWidthPxMax"
    >
      <div id="timeline-title-and-footer-container">
        <div
          id="timeline-title-container"
          v-bind:style="$_timelineTitleContainerStyle"
        >
          <timeline-title
            class="timeline-title"
            v-for="(visibleTimelineDataId, visibleTimelineDataIdx) of visibleTimelineDataIdxToId"
            v-bind:key="visibleTimelineDataIdx"
            v-bind:visible-timeline-data-id="visibleTimelineDataId"
            v-bind:visible-timeline-data-idx="visibleTimelineDataIdx"
            v-bind:timeline-title="visibleTimelineDataSet[visibleTimelineDataId].name"
            v-bind:timeline-height-px="$_timelineHeightPx"
            v-bind:timeline-readonly="visibleTimelineDataSet[visibleTimelineDataId].readonly"
            v-bind:timeline-locked="visibleTimelineDataSet[visibleTimelineDataId].locked"
            v-bind:is-realtime-segment-creation-target="$_isRealtimeSegmentCreationTarget[visibleTimelineDataIdx]"
            v-bind:menu-contents="$_menuContentsTimelineTitle[visibleTimelineDataIdx]"
            v-on:select-all-visible-segments="$_selectAllVisibleSegments"
            v-on:toggle-set-or-unset-realtime-segment-creation-target="$_toggleSetOrUnsetRealtimeSegmentCreationTarget"
          >
          </timeline-title>
          <generate-new-timeline-data-button
            class="timeline-title"
            v-bind:timeline-height-px="$_timelineHeightPx"
            v-bind:menu-contents="$_menuContentsGenerateNewTimelineData"
          >
          </generate-new-timeline-data-button>
        </div>
        <timeline-title-footer
          v-bind:is-mouse-mode.sync="$_isMouseMode"
          v-bind:is-snap-enabled.sync="$_isSnapEnabled"
        >
        </timeline-title-footer>
      </div>
    </resizable-frame>
    <div id="timeline-container">
      <div
        id="timeline-canvas-container"
        ref="timelineCanvasContainer"
        v-bind:class="$_timelineCanvasContainerClass"
      >
        <timeline-background-canvas
          id="timeline-background-canvas"
          ref="timelineBackgroundCanvas"
          v-bind:ruler-vertical-offset-px="$_rulerVerticalOffsetPx"
          v-bind:num-visible-timelines="$_numVisibleTimelines"
          v-bind:vertical-offset-px="$data.$_verticalOffsetPx"
          v-bind:timeline-height-px="$_timelineHeightPx"
          v-bind:waveform-digest="waveformDigest"
          v-bind:timeline-view-begin="$data.$_timelineViewBegin"
          v-bind:timeline-view-end="$_timelineViewEnd"
          v-bind:timeline-view-duration="$_timelineViewDuration"
          v-bind:is-loop-enabled="isLoopEnabled"
          v-bind:loop-definition="loopDefinition"
          v-bind:waveform-scale="$data.$_waveformScale"
        >
        </timeline-background-canvas>
        <timeline-segment-canvas
          id="timeline-segment-canvas"
          ref="timelineSegmentCanvas"
          v-bind:ruler-vertical-offset-px="$_rulerVerticalOffsetPx"
          v-bind:vertical-offset-px="$data.$_verticalOffsetPx"
          v-bind:timeline-height-px="$_timelineHeightPx"
          v-bind:timeline-segment-dom-rects="$_timelineSegmentDomRects"
          v-bind:time-resolution="$data.$_timeResolution"
          v-bind:selected-timeline-segment-ids="selectedTimelineSegmentIds"
          v-bind:visible-timeline-data-set="visibleTimelineDataSet"
          v-bind:visible-timeline-data-idx-to-id="visibleTimelineDataIdxToId"
        >
        </timeline-segment-canvas>
        <timeline-foreground-canvas
          id="timeline-foreground-canvas"
          ref="timelineForegroundCanvas"
          v-bind:timeline-view-begin="$data.$_timelineViewBegin"
          v-bind:timeline-view-end="$_timelineViewEnd"
          v-bind:timeline-view-duration="$_timelineViewDuration"
          v-bind:timeline-marker="timelineMarker"
        >
        </timeline-foreground-canvas>
        <timeline-play-time-bar-canvas
          id="timeline-play-time-bar-canvas"
          ref="timelinePlayTimeBarCanvas"
          v-bind:ruler-vertical-offset-px="$_rulerVerticalOffsetPx"
          v-bind:play-time="playTime"
          v-bind:is-play-time-in-view="$_isPlayTimeInView"
          v-bind:follow-play-bar-flag="$data.$_followPlayBarFlag"
          v-bind:timeline-view-begin="$data.$_timelineViewBegin"
        >
        </timeline-play-time-bar-canvas>
        <timeline-overlay-canvas
          id="timeline-overlay-canvas"
          ref="timelineOverlayCanvas"
          v-bind:time-and-timeline-position-at-mousedown="$data.$_timeAndTimelinePositionAtMousedown"
          v-bind:time-and-timeline-position-at-mousemove="$data.$_timeAndTimelinePositionAtMousemove"
          v-bind:is-dragging="$data.$_isDragging"
          v-bind:first-mouse-button-at-mousedown="$data.$_firstMouseButtonAtMousedown"
          v-bind:is-mousedown-on-scroll-bar="$data.$_isMousedownOnScrollBar"
          v-bind:is-mousedown-on-ruler-area="$data.$_isMousedownOnRulerArea"
          v-bind:is-mousemove-on-timeline-canvas="$_isMousemoveOnTimelineCanvas"
          v-bind:timeline-segment-dom-rects-to-drag-with-info="$_timelineSegmentDomRectsToDragWithInfo"
          v-bind:segment-drag-offset-time="$data.$_segmentDragOffsetTime"
          v-bind:num-visible-timelines="$_numVisibleTimelines"
          v-bind:view-mode="$data.$_currentViewMode"
          v-bind:vertical-offset-px="$data.$_verticalOffsetPx"
          v-bind:timeline-height-px="$_timelineHeightPx"
          v-bind:minimum-segment-duration="minimumSegmentDuration"
          v-bind:timeline-view-begin-min="timelineViewBeginMin"
          v-bind:timeline-view-end-max="timelineViewEndMax"
          v-bind:timeline-marker="timelineMarker"
        >
        </timeline-overlay-canvas>
        <time-scroll-bar-canvas
          id="time-scroll-bar-canvas"
          ref="timeScrollBarCanvas"
          v-bind:time-scroll-bar-canvas-height-px="$data.$_timelineScrollBarWidthPx"
          v-bind:time-scroll-bar-dom-rect="$_timeScrollBarDomRect"
        >
        </time-scroll-bar-canvas>
        <timeline-list-menu ref="timelineListMenu">
        </timeline-list-menu>
      </div>
      <timeline-info-bar
        v-bind:timeline-view-begin-min="timelineViewBeginMin"
        v-bind:timeline-view-end-max="timelineViewEndMax"
        v-bind:play-time="playTime"
        v-bind:visible-timeline-data-set="visibleTimelineDataSet"
        v-bind:selected-timeline-segment-ids="selectedTimelineSegmentIds"
        v-bind:view-mode.sync="$data.$_currentViewMode"
        v-bind:time-resolution.sync="$data.$_timeResolution"
        v-bind:time-resolution-min="$data.$_timeResolutionMin"
        v-bind:time-resolution-max="$_timeResolutionMax"
        v-bind:timeline-position-resolution.sync="$data.$_timelinePositionResolution"
        v-bind:timeline-position-resolution-min="$_timelinePositionResolutionMin"
        v-bind:timeline-position-resolution-max="$_timelinePositionResolutionMax"
        v-bind:waveform-scale.sync="$data.$_waveformScale"
        v-bind:waveform-scale-min="$_waveformScaleMin"
        v-bind:waveform-scale-max="$_waveformScaleMax"
      >
      </timeline-info-bar>
    </div>
  </div>
</template>

<style scoped>
#timeline-list-container {
  user-select: none;
  flex-grow: 1;
  display: flex;
  overflow: hidden;
  height: 100%;
}

#timeline-title-and-footer-container {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  position: relative;
  height: 100%;
}

#timeline-title-container {
  position: absolute;
  width: 100%;
}

.timeline-title {
  position: relative;
}

#timeline-container {
  display: flex;
  flex-direction: column;
  flex: auto;
  background-color: #f1f1f1;
  overflow-x: hidden;
}

#timeline-canvas-container {
  position: relative;
  flex: auto;
  background-color: #f1f1f1;
}

#timeline-background-canvas,
#timeline-segment-canvas,
#timeline-foreground-canvas,
#timeline-play-time-bar-canvas,
#timeline-overlay-canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

#time-scroll-bar-canvas {
  outline: none;
  position: absolute;
  width: 100%;
  height: 10px;
  bottom: 0;
  left: 0;
}

.timeline-canvas-view-mode-normal.mouse-cursor-on-timeline-segment,
.timeline-canvas-view-mode-select.mouse-cursor-on-timeline-segment,
.timeline-canvas-view-mode-divide.mouse-cursor-on-timeline-segment,
.timeline-canvas-view-mode-position.mouse-cursor-on-timeline-segment {
  cursor: pointer;
}

.timeline-canvas-view-mode-select.mouse-cursor-on-timeline-selected-segment,
.timeline-canvas-view-mode-position.mouse-cursor-on-timeline-selected-segment {
  cursor: move;
}

.timeline-canvas-view-mode-select.mouse-cursor-on-timeline-selected-segment-edge,
.timeline-canvas-view-mode-position.mouse-cursor-on-timeline-selected-segment-edge {
  cursor: ew-resize;
}

.timeline-canvas-view-mode-create.mouse-cursor-on-timeline {
  cursor: crosshair;
}

.timeline-canvas-view-mode-divide.mouse-cursor-on-timeline-selected-segment,
.timeline-canvas-view-mode-divide.mouse-cursor-on-timeline-selected-segment-edge {
  cursor: text;
}

.mouse-cursor-on-scroll-bar-area,
.mouse-cursor-on-ruler-area {
  cursor: default !important;
}
</style>

<style src="../styles/common.css" scoped></style>

<script>
import TimelineInfoBar from './TimelineListView/TimelineInfoBar.vue';
import TimelineTitle from './TimelineListView/TimelineTitle.vue';
import TimelineTitleFooter from './TimelineListView/TimelineTitleFooter.vue';
import GenerateNewTimelineDataButton from './TimelineListView/GenerateNewTimelineDataButton.vue';
import TimelineListMenu from './TimelineListView/TimelineListMenu.vue';
import TimelineBackgroundCanvas from './TimelineListView/canvases/TimelineBackgroundCanvas.vue';
import TimelineSegmentCanvas from './TimelineListView/canvases/TimelineSegmentCanvas.vue';
import TimelineForegroundCanvas from './TimelineListView/canvases/TimelineForegroundCanvas.vue';
import TimelinePlayTimeBarCanvas from './TimelineListView/canvases/TimelinePlayTimeBarCanvas.vue';
import TimelineOverlayCanvas from './TimelineListView/canvases/TimelineOverlayCanvas.vue';
import TimelineSegmentDomRectsToDragWithInfo from './TimelineListView/canvases/modules/TimelineSegmentDomRectsToDragWithInfo.js';
import TimeScrollBarCanvas from './TimelineListView/canvases/TimeScrollBarCanvas.vue';
import ResizableFrame from './Parts/ResizableFrame.vue';
import { TimelineDataSet, TimelineSegmentId } from '../modules/ScattData.js';
import viewMode from './TimelineListView/modules/viewMode.js';
import utils from '../modules/utils.js';
import logger from '../modules/logger.js';
import TimelineCanvasLocalCoords from './TimelineListView/canvases/modules/TimelineCanvasLocalCoords.js';
import TimeAndTimelinePosition from './TimelineListView/canvases/modules/TimeAndTimelinePosition.js';
import TimeValue from '../modules/TimeValue.js';
import TimelineMarker from '../modules/TimelineMarker.js';
import LoopDefinition from '../modules/LoopDefinition.js';
import WaveformDigest from '../modules/WaveformDigest.js';
import mouseEventUtils, { mouseButtonEnum } from '../modules/mouseEventUtils.js';

const materialDesignFont = new FontFace('material-design-icons', 'url(https://fonts.gstatic.com/s/materialicons/v48/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2)');

const timeStepPxOnScroll = 60;
const timelineViewPreBeginMarginPxMax = 20;
const timeResolutionMax = 16;
const timelinePositionResolutionMin = 0.5;
const timelinePositionResolutionMax = 3;
const verticalStepPxOnScroll = 30;
const timelineSegmentVerticalMarginPx = 2;
const unitTimelineHeightPx = 60;
const timeScrollBarDurationPxMin = 20;
const timelineTitleWidthPxMin = 100;
const timelineViewWidthPxMin = 100;
const possibleSingleClickMousemovePx = 20;
const singleClickDurationMsecMax = 100;
const doubleClickIntervalOnTimelineSegmentMsecMax = 300;
const waveformScaleMin = 1;
const waveformScaleMax = 12;

const rulerVerticalOffsetPx = 16;
const timelineViewEdgeWidthPx = 20;
const timelineSegmentEdgeWidth = 5;
const snapWidthPx = 10;

const seekMarginTimeOnEndOfSegmentPositionChanged = TimeValue.msec(500);

class TimelineListViewMenuContent {
  static name = 'TimelineListViewMenuContent';

  constructor(name, callback, disabled) {
    this.name = name;
    this.callback = callback;
    this.disabled = disabled;
  }
}

class EdgeInfo {
  static name = 'EdgeInfo';

  constructor(coords, timelineCanvasContainerWidthPx, timelineCanvasContainerHeightPx) {
    this.isOnLeftEdge = (coords.x < timelineViewEdgeWidthPx);
    this.isOnRightEdge = ((timelineCanvasContainerWidthPx - coords.x) < timelineViewEdgeWidthPx);
    this.isOnTopEdge = (coords.y < timelineViewEdgeWidthPx);
    this.isOnBottomEdge = ((timelineCanvasContainerHeightPx - coords.y) < timelineViewEdgeWidthPx);
  }
}

class TimelineSegmentIdWithInfo {
  static name = 'TimelineSegmentIdWithInfo';

  constructor(timelineSegmentId, timelineSegmentDomRect, timelineCanvasLocalCoords) {
    this.timelineSegmentId = timelineSegmentId;
    this.timelineSegmentDomRect = timelineSegmentDomRect;
    let isOnLeftEdge = false;
    let isOnRightEdge = false;
    let offsetPxByLeftEdge = timelineCanvasLocalCoords.x - timelineSegmentDomRect.x;
    let offsetPxByRightEdge = timelineCanvasLocalCoords.x - (timelineSegmentDomRect.x + timelineSegmentDomRect.width);
    if (timelineSegmentDomRect.width >= (2 * timelineSegmentEdgeWidth)) {
      let leftEdgeDomRect = new DOMRect(
        timelineSegmentDomRect.x,
        timelineSegmentDomRect.y,
        timelineSegmentEdgeWidth,
        timelineSegmentDomRect.height,
      );
      isOnLeftEdge = utils.isInRect(leftEdgeDomRect, timelineCanvasLocalCoords.x, timelineCanvasLocalCoords.y);
      let rightEdgeDomRect = new DOMRect(
        timelineSegmentDomRect.x + timelineSegmentDomRect.width - timelineSegmentEdgeWidth,
        timelineSegmentDomRect.y,
        timelineSegmentEdgeWidth,
        timelineSegmentDomRect.height,
      );
      isOnRightEdge = utils.isInRect(rightEdgeDomRect, timelineCanvasLocalCoords.x, timelineCanvasLocalCoords.y);
    }
    this.isOnLeftEdge = isOnLeftEdge;
    this.isOnRightEdge = isOnRightEdge;
    this.offsetPxByLeftEdge = offsetPxByLeftEdge;
    this.offsetPxByRightEdge = offsetPxByRightEdge;
  }
}

function resolve(value, resolution) {
  if (resolution === 0) throw 'resolution is zero';
  if (resolution === Infinity) throw 'resolution is infinity';
  return value / resolution;
}

function unitize(value, resolution) {
  if (resolution === Infinity) throw 'resolution is infinity';
  return value * resolution;
}

export default {
  components: {
    TimelineInfoBar,
    TimelineTitle,
    TimelineTitleFooter,
    GenerateNewTimelineDataButton,
    TimelineBackgroundCanvas,
    TimelineForegroundCanvas,
    TimelineSegmentCanvas,
    TimelinePlayTimeBarCanvas,
    TimelineOverlayCanvas,
    TimeScrollBarCanvas,
    TimelineListMenu,
    ResizableFrame,
  },

  watch: {
    visibleTimelineDataSet: {
      handler(newVisibleTimelineDataSet) {
        let timelineDataIdsTemp = [ ...this.$data.$_realtimeSegmentCreationTargetTimelineDataIds ];
        for (let timelineDataId of timelineDataIdsTemp) {
          if (Object.keys(newVisibleTimelineDataSet).includes(timelineDataId)) {
            let timelineData = newVisibleTimelineDataSet[timelineDataId];
            if (timelineData.locked) {
              let timelineDataIdIdx = this.$data.$_realtimeSegmentCreationTargetTimelineDataIds.indexOf(timelineDataId);
              this.$data.$_realtimeSegmentCreationTargetTimelineDataIds.splice(timelineDataIdIdx, 1);
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    timelineViewBeginMin: {
      handler() { this.$_initializeView() },
      deep: true,
    },
    timelineViewEndMax: {
      handler() { this.$_initializeView() },
      deep: true,
    },
    playTime: {
      handler(newPlayTime) {
        if (!this.$_isPlayTimeInView) {
          if (this.$data.$_followPlayBarFlag) {
            this.$_setTimelineViewBegin(newPlayTime);
          }
        }
        if (this.$data.$_isRealtimeSegmentOpen) {
          if (this.$_isMarkerSet) {
            if (this.timelineMarker.begin.isLessThan(newPlayTime)) {
              this.setMarker(this.timelineMarker.begin, newPlayTime);
            } else {
              this.setMarker(newPlayTime, newPlayTime);
            }
          } else {
            this.$data.$_isRealtimeSegmentOpen = false;
          }
        }
      },
      deep: true,
    },
    '$data.$_currentViewMode'(newCurrentViewMode) {
      switch(newCurrentViewMode) {
      case viewMode.normal:
        this.clearSelectedTimelineSegments();
        break;
      case viewMode.position:
        this.invokeActionOnSelectedTimelineSegments('setLoop');
        this.invokeActionOnSelectedTimelineSegments('setMarker');
        break;
      }
    },
    $_isAnyTimelineRealtimeSegmentCreationTarget(newIsAnyTimelineRealtimeSegmentCreationTarget) {
      if (!newIsAnyTimelineRealtimeSegmentCreationTarget) {
        this.$data.$_isRealtimeSegmentOpen = false;
      }
    },
    isVideoPlaying(newIsVideoPlaying) {
      if (!newIsVideoPlaying && this.$data.$_isRealtimeSegmentOpen) {
        this.$_recordRealtimeSegmentEnd();
      }
    },
    $_lastSelectedTimelineSegmentId(lastSelectedTimelineSegmentId) {
      if (lastSelectedTimelineSegmentId === undefined) return;
      switch(this.$data.$_currentViewMode) {
      case viewMode.position:
        this.$_initializePositionEditTargetTimelineSegment(lastSelectedTimelineSegmentId);
        this.invokeActionOnSelectedTimelineSegments('setLoop');
        this.invokeActionOnSelectedTimelineSegments('setMarker');
        break;
      }
    },
  },

  props: {
    playTime:                              { type: TimeValue },
    isVideoPlaying:                        { type: Boolean },
    visibleTimelineDataSet:                { type: TimelineDataSet },
    visibleTimelineDataIdxToId:            { type: Array },
    sortedVisibleSegmentIdxToIdMaps:       { type: Map },
    visibleSegmentIdToSortedIdxMaps:       { type: Map },
    waveformDigest:                        { type: WaveformDigest },
    minimumSegmentDuration:                { type: TimeValue },
    selectedTimelineSegmentIds:            { type: Array },
    isAnySelectedTimelineSegmentImmutable: { type: Boolean },
    isLoopEnabled:                         { type: Boolean },
    isMouseMode:                           { type: Boolean },
    isSnapEnabled:                         { type: Boolean },
    loopDefinition:                        { type: LoopDefinition },
    timelineMarker:                        { type: TimelineMarker },
    segmentDataTypes:                      { type: Array },
    timelineTitleWidthPx:                  { type: Number },
    timelineViewBeginMin:                  { type: TimeValue, default: () => TimeValue.sec(0) },
    timelineViewEndMax:                    { type: TimeValue, default: () => TimeValue.sec(10) },
  },

  data() {
    return {
      $_requestAnimationFrameCallbackId: undefined,

      $_timelinePositionResolution: timelinePositionResolutionMin,
      $_timelineViewBegin: TimeValue.zero,
      $_timeResolution: 1,
      $_timeResolutionMin: 1,
      $_verticalOffsetPx: rulerVerticalOffsetPx,

      $_timelineCanvasContainerResizeObserver: new ResizeObserver(this.$_updateViewSize),
      $_timelineListContainerWidthPx: timelineViewWidthPxMin,
      $_timelineCanvasContainerBoundingClientRect: undefined,
      $_timelineScrollBarWidthPx: 0,

      $_timeAndTimelinePositionAtMousedown: undefined,
      $_timelineSegmentIdWithInfoAtMousedown: undefined,
      $_edgeInfoAtMousedown: undefined,
      $_firstMouseButtonAtMousedown: undefined,
      $_timelineCanvasLocalXAtMousedownOnScrollBar: undefined,
      $_timelineViewBeginAtMousedownOnScrollBar: undefined,
      $_isMousedownOnScrollBar: false,
      $_isMousedownOnRulerArea: false,
      $_isInSingleClickTimeRange: false,
      $_isDragging: false,

      $_timeAndTimelinePositionAtMousemove: new TimeAndTimelinePosition(),
      $_timelineCanvasLocalCoordsAtMousemove: new TimelineCanvasLocalCoords(),

      $_waveformScale: 1,
      $_segmentDragOffsetTime: TimeValue.zero,

      $_timelineSegmentNearestBaseTime: TimeValue.zero,
      $_followPlayBarFlag: true,
      $_currentViewMode: viewMode.normal,

      $_timelineSegmentIdAtLastClick: undefined,
      $_doubleClickOnTimelineSegmentTimeout: undefined,

      $_isAutoScrollPending: false,
      $_autoScrollXInterval: undefined,
      $_autoScrollYInterval: undefined,

      $_isRealtimeSegmentOpen: false,
      $_realtimeSegmentCreationTargetTimelineDataIds: [],

      $_positionEditTargetTimelineSegmentId: undefined,
      $_positionEditTargetTimelineSegmentBegin: undefined,
      $_positionEditTargetTimelineSegmentEnd: undefined,
    }
  },

  computed: {
    $_timeResolutionMax() { return timeResolutionMax },
    $_timelinePositionResolutionMin() { return timelinePositionResolutionMin },
    $_timelinePositionResolutionMax() { return timelinePositionResolutionMax },
    $_waveformScaleMin() { return waveformScaleMin },
    $_waveformScaleMax() { return waveformScaleMax },
    $_rulerVerticalOffsetPx()    { return rulerVerticalOffsetPx; },
    $_timelineTitleWidthPx: {
      get()                        { return this.timelineTitleWidthPx },
      set(newTimelineTitleWidthPx) { this.$emit( 'update:timeline-title-width-px', newTimelineTitleWidthPx) },
    },
    $_timelineTitleWidthPxMin() { return timelineTitleWidthPxMin },
    $_timelineTitleWidthPxMax() { return this.$data.$_timelineListContainerWidthPx - timelineViewWidthPxMin; },
    $_timelineCanvasContainerHeightPx() {
      if (this.$data.$_timelineCanvasContainerBoundingClientRect === undefined) return 0;
      return this.$data.$_timelineCanvasContainerBoundingClientRect.height;
    },
    $_timelineCanvasContainerWidthPx() {
      if (this.$data.$_timelineCanvasContainerBoundingClientRect === undefined) return 0;
      return this.$data.$_timelineCanvasContainerBoundingClientRect.width;
    },
    $_timelineCanvasWidthPx() {
      return this.$_timelineCanvasContainerWidthPx;
    },
    $_timelineCanvasHeightPx() {
      return this.$_timelineCanvasContainerHeightPx - this.$data.$_timelineScrollBarWidthPx;
    },
    $_timelineViewEnd()      { return this.$data.$_timelineViewBegin.add(this.$_timelineViewDuration); },
    $_timelineViewDuration() { return this.$_pxToScaledTime(this.$_timelineCanvasWidthPx); },
    $_timelineHeightPx()     { return Math.round(unitTimelineHeightPx * this.$data.$_timelinePositionResolution); },
    $_isMarkerSet()          { return (this.timelineMarker !== undefined) },
    $_isPlayTimeInView()     { return this.$_isTimeInView(this.playTime) },

    $_isAnyTimelineRealtimeSegmentCreationTarget() {
      return (this.$data.$_realtimeSegmentCreationTargetTimelineDataIds.length > 0);
    },

    $_isRealtimeSegmentCreationTarget() {
      return Object.keys(this.visibleTimelineDataSet).map(
        timelineDataId => this.$data.$_realtimeSegmentCreationTargetTimelineDataIds.includes(timelineDataId)
      );
    },

    $_timelineSegmentIdWithInfoAtMousemove() {
      {
        let timelineSegmentIdsAtMouseCursor = findTimelineSegmentIdsAtMouseCursor.call(this, this.$data.$_timelineCanvasLocalCoordsAtMousemove);
        if (timelineSegmentIdsAtMouseCursor.length === 0) return undefined;
        let alreadySelectedTimelineSegmentIds = findAlreadySelectedTimelineSegmentIds.call(this, timelineSegmentIdsAtMouseCursor);
        let timelineSegmentIdAtMouseCursor = getRepresentativeTimelineSegmentIds((alreadySelectedTimelineSegmentIds.length > 0)? alreadySelectedTimelineSegmentIds : timelineSegmentIdsAtMouseCursor);
        let timelineDataIdAtMouseCursor = timelineSegmentIdAtMouseCursor.timelineDataId;
        let segmentIdAtMouseCursor = timelineSegmentIdAtMouseCursor.segmentId;
        let timelineSegmentDomRectAtMouseCursor = this.$_timelineSegmentDomRects[timelineDataIdAtMouseCursor][segmentIdAtMouseCursor];
        return new TimelineSegmentIdWithInfo(
          timelineSegmentIdAtMouseCursor,
          timelineSegmentDomRectAtMouseCursor,
          this.$data.$_timelineCanvasLocalCoordsAtMousemove,
        );
      }

      function getRepresentativeTimelineSegmentIds(timelineSegmentIds) {
        return timelineSegmentIds[timelineSegmentIds.length - 1];
      }

      function findAlreadySelectedTimelineSegmentIds(timelineSegmentIds) {
        let alreadySelectedTimelineSegmentIds = [];
        for (let timelineSegmentId of timelineSegmentIds) {
          if (this.$_isTimelineSegmentIdSelected(timelineSegmentId)) {
            alreadySelectedTimelineSegmentIds.push(timelineSegmentId);
          }
        }
        return alreadySelectedTimelineSegmentIds;
      }

      function findTimelineSegmentIdsAtMouseCursor(timelineCanvasLocalCoordsAtMouseCursor) {
        let timelineSegmentIdsAtPoint = [];
        for (let [ timelineDataId, segmentDomRectsByTimelineDataId ] of Object.entries(this.$_timelineSegmentDomRects)) {
          for (let [ segmentId, timelineSegmentDomRect ] of Object.entries(segmentDomRectsByTimelineDataId)) {
            if (utils.isInRect(timelineSegmentDomRect, timelineCanvasLocalCoordsAtMouseCursor.x, timelineCanvasLocalCoordsAtMouseCursor.y)) {
              timelineSegmentIdsAtPoint.push(new TimelineSegmentId(timelineDataId, segmentId));
            }
          }
        }
        return timelineSegmentIdsAtPoint;
      }
    },

    $_timelineTitleContainerStyle() {
      return {
        top: `${this.$data.$_verticalOffsetPx}px`,
      };
    },

    $_isMouseCursorOnScrollBarArea() {
      return (this.$data.$_timelineCanvasLocalCoordsAtMousemove.y >= this.$_timelineCanvasHeightPx) &&
        (this.$data.$_timelineCanvasLocalCoordsAtMousemove.y < this.$_timelineCanvasContainerHeightPx) &&
        (this.$data.$_timelineCanvasLocalCoordsAtMousemove.x >= 0) &&
        (this.$data.$_timelineCanvasLocalCoordsAtMousemove.x < this.$_timelineCanvasContainerWidthPx);
    },

    $_isMouseCursorOnRulerArea() {
      return (this.$data.$_timelineCanvasLocalCoordsAtMousemove.y >= 0) &&
        (this.$data.$_timelineCanvasLocalCoordsAtMousemove.y < rulerVerticalOffsetPx);
    },

    $_isMouseCursorOnVisibleTimeline() {
      return (this.$_timelineCanvasLocalYToVisibleTimelineDataIdx(this.$data.$_timelineCanvasLocalCoordsAtMousemove.y) !== undefined);
    },

    $_isMousemoveOnTimelineCanvas() {
      if (this.$data.$_timelineCanvasLocalCoordsAtMousemove.x > this.$_timelineCanvasWidthPx) return false;
      if (this.$data.$_timelineCanvasLocalCoordsAtMousemove.x < 0) return false;
      if (this.$data.$_timelineCanvasLocalCoordsAtMousemove.y > this.$_timelineCanvasHeightPx) return false;
      if (this.$data.$_timelineCanvasLocalCoordsAtMousemove.y < 0) return false;
      return true;
    },

    $_isMouseEventStarted() {
      return (this.$data.$_firstMouseButtonAtMousedown !== undefined);
    },

    $_isPresumableAsClick() {
      if (this.$_timelineCanvasLocalXAtMousedown === undefined) return false;
      if (this.$_timelineCanvasLocalYAtMousedown === undefined) return false;
      if (!this.$data.$_isInSingleClickTimeRange) return false;
      let singleClickMousemovePx = Math.sqrt(
        Math.pow(this.$data.$_timelineCanvasLocalCoordsAtMousemove.x - this.$_timelineCanvasLocalXAtMousedown, 2) +
        Math.pow(this.$data.$_timelineCanvasLocalCoordsAtMousemove.y - this.$_timelineCanvasLocalYAtMousedown, 2)
      );
      if (singleClickMousemovePx > possibleSingleClickMousemovePx) return false;
      return true;
    },

    $_verticalOffsetPxMin() {
      if (this.$_numVisibleTimelines === 0) {
        return rulerVerticalOffsetPx;
      } else {
        return -this.$_timelineHeightPx * (this.$_numVisibleTimelines - 1) + rulerVerticalOffsetPx;
      }
    },

    $_timelineViewBeginMinIncludingMargin() {
      return this.$_pxToScaledTime(-timelineViewPreBeginMarginPxMax).add(this.timelineViewBeginMin);
    },

    $_timelineCanvasLocalXAtMousedown() {
      if (this.$data.$_timeAndTimelinePositionAtMousedown === undefined) return undefined;
      if (this.$_isOnSegmentAtMousedown) {
        return this.$_timeToTimelineCanvasLocalX(this.$data.$_timeAndTimelinePositionAtMousedown.time);
      } else {
        return this.$_timeToTimelineCanvasLocalX(this.$data.$_timeAndTimelinePositionAtMousedown.snappedTime);
      }
    },

    $_timelineCanvasLocalYAtMousedown() {
      if (this.$data.$_timeAndTimelinePositionAtMousedown === undefined) return undefined;
      return this.$_timelinePositionToTimelineCanvasLocalY(this.$data.$_timeAndTimelinePositionAtMousedown.timelinePosition);
    },

    $_isOnSegmentAtMousedown() {
      return (this.$data.$_timelineSegmentIdWithInfoAtMousedown !== undefined);
    },

    $_onlyOneSelectedTimelineSegmentId() {
      if (this.selectedTimelineSegmentIds.length === 1) {
        return this.$_lastSelectedTimelineSegmentId;
      } else {
        return undefined;
      }
    },

    $_lastSelectedTimelineSegmentId() {
      if (this.$_isAnyTimelineSegmentIdSelected) {
        return this.selectedTimelineSegmentIds[this.selectedTimelineSegmentIds.length - 1];
      } else {
        return undefined;
      }
    },

    $_isAnyTimelineSegmentIdSelected() {
      return (this.selectedTimelineSegmentIds.length > 0);
    },

    $_isDraggingSegments() {
      if (!this.$_isOnSegmentAtMousedown) return false;
      if (this.$data.$_firstMouseButtonAtMousedown !== mouseButtonEnum.main) return false;
      switch(this.$data.$_currentViewMode) {
      case viewMode.select:
      case viewMode.position:
        break;
      default:
        return false;
      }
      if (!this.$data.$_isDragging) return false;
      return true;
    },

    $_timelineSegmentDomRectsToDragWithInfo() {
      if (!this.$_isDraggingSegments) return undefined;
      let timelineSegmentIdAtMousedown = this.$data.$_timelineSegmentIdWithInfoAtMousedown.timelineSegmentId;
      if (this.$_isTimelineSegmentIdSelected(timelineSegmentIdAtMousedown)) {
        let selectedTimelineSegmentDomRects = this.selectedTimelineSegmentIds.map(timelineSegmentId => {
          let timelineDataId = timelineSegmentId.timelineDataId;
          let segmentId = timelineSegmentId.segmentId;
          return this.$_timelineSegmentDomRects[timelineDataId][segmentId];
        });
        let endTypes = this.selectedTimelineSegmentIds.map(timelineSegmentId => {
          let timelineDataId = timelineSegmentId.timelineDataId;
          let segmentId = timelineSegmentId.segmentId;
          let segment = this.visibleTimelineDataSet[timelineDataId].segments[segmentId];
          if (segment.begin === null) {
            if (segment.end === null) {
              return TimelineSegmentDomRectsToDragWithInfo.endType.bothEndInfinite;
            } else {
              return TimelineSegmentDomRectsToDragWithInfo.endType.leftEndInfinite;
            }
          } else {
            if (segment.end === null) {
              return TimelineSegmentDomRectsToDragWithInfo.endType.rightEndInfinite;
            } else {
              return TimelineSegmentDomRectsToDragWithInfo.endType.bothEndFinite;
            }
          }
        });
        let edgeType = undefined;
        if (this.$data.$_timelineSegmentIdWithInfoAtMousedown.isOnLeftEdge) {
          edgeType = TimelineSegmentDomRectsToDragWithInfo.edgeType.left;
        } else if (this.$data.$_timelineSegmentIdWithInfoAtMousedown.isOnRightEdge) {
          edgeType = TimelineSegmentDomRectsToDragWithInfo.edgeType.right;
        } else {
          edgeType = TimelineSegmentDomRectsToDragWithInfo.edgeType.none;
        }
        return new TimelineSegmentDomRectsToDragWithInfo(selectedTimelineSegmentDomRects, endTypes, edgeType);
      }
      return undefined;
    },

    $_menuContentsTimelineTitle() {
      {
        return this.visibleTimelineDataIdxToId.map(
          (timelineDataId, visibleTimelineDataIdx) => {
            let isTimelineDataLocked = this.visibleTimelineDataSet[timelineDataId].locked;
            let isTimelineDataReadonly = this.visibleTimelineDataSet[timelineDataId].readonly;
            let isTimelineDataImmutable = isTimelineDataReadonly || isTimelineDataLocked;
            let isFirstVisibleTimeline = (visibleTimelineDataIdx === 0);
            let isLastVisibleTimeline = (visibleTimelineDataIdx === (this.visibleTimelineDataIdxToId.length - 1));
            let isMarkerNotSet = !this.$_isMarkerSet;
            return [
              new TimelineListViewMenuContent(
                'Select all segments',
                this.$_selectAllVisibleSegments,
                false
              ),
              new TimelineListViewMenuContent(
                'Create new segment on marker',
                createNewSegmentOnMarker.bind(this),
                isMarkerNotSet || isTimelineDataImmutable
              ),
              new TimelineListViewMenuContent(
                'Import from other timelines',
                importFromOtherTimelines.bind(this),
                isTimelineDataImmutable
              ),
              new TimelineListViewMenuContent(
                'Remove timeline',
                removeTimeline.bind(this),
                isTimelineDataImmutable
              ),
              new TimelineListViewMenuContent(
                'Hide timeline',
                hideTimeline.bind(this),
                false
              ),
              new TimelineListViewMenuContent(
                'Rename timeline',
                renameTimelineId.bind(this),
                isTimelineDataImmutable
              ),
              new TimelineListViewMenuContent(
                'Duplicate timeline',
                duplicateTimeline.bind(this),
                false
              ),
              new TimelineListViewMenuContent(
                'Move up',
                moveUp.bind(this),
                isFirstVisibleTimeline
              ),
              new TimelineListViewMenuContent(
                'Move down',
                moveDown.bind(this),
                isLastVisibleTimeline
              ),
            ];
          }
        );
      }

      async function createNewSegmentOnMarker(visibleTimelineDataIdx) {
        let timelineDataId = this.visibleTimelineDataIdxToId[visibleTimelineDataIdx];
        let newTimelineSegmentId = await this.createSegment(timelineDataId, this.timelineMarker.begin.round(), this.timelineMarker.end.round());
        if (newTimelineSegmentId !== undefined) {
          this.$_selectTimelineSegmentCore(newTimelineSegmentId, { retainsViewMode: true });
        }
      }

      function importFromOtherTimelines(visibleTimelineDataIdx) {
        let timelineDataId = this.visibleTimelineDataIdxToId[visibleTimelineDataIdx];
        this.importTimelineDataFromExistingTimelines(timelineDataId);
      }

      function removeTimeline(visibleTimelineDataIdx) {
        let timelineDataId = this.visibleTimelineDataIdxToId[visibleTimelineDataIdx];
        this.removeTimelineData(timelineDataId);
      }

      function hideTimeline(visibleTimelineDataIdx) {
        let timelineDataId = this.visibleTimelineDataIdxToId[visibleTimelineDataIdx];
        this.hideTimelineData(timelineDataId);
      }

      function duplicateTimeline(visibleTimelineDataIdx) {
        let timelineDataId = this.visibleTimelineDataIdxToId[visibleTimelineDataIdx];
        this.duplicateTimelineData(timelineDataId);
      }

      async function renameTimelineId(visibleTimelineDataIdx) {
        let timelineDataId = this.visibleTimelineDataIdxToId[visibleTimelineDataIdx];
        await this.renameTimelineData(timelineDataId);
      }

      function moveUp(visibleTimelineDataIdx) {
        this.incrementVisibleTimelineDataIdx(visibleTimelineDataIdx, true);
      }

      function moveDown(visibleTimelineDataIdx) {
        this.incrementVisibleTimelineDataIdx(visibleTimelineDataIdx, false);
      }
    },

    $_menuContentsGenerateNewTimelineData() {
      return [
        ...this.segmentDataTypes.map(
          segmentDataType => {
            let menuContentName = `Generate New ${segmentDataType.name} Timeline`;
            let defaultTimelineDataName = `New ${segmentDataType.name} Timeline`;
            return new TimelineListViewMenuContent(
              menuContentName,
              async () => { await this.generateNewTimelineData(segmentDataType, defaultTimelineDataName, false) },
              false
            )
          },
        ),
        new TimelineListViewMenuContent(
          'Generate New Timeline From Existing Timelines',
          () => { this.generateNewTimelineDataFromExistingTimelines(false) },
          false
        ),
      ];
    },

    $_menuContentsForTimelineListOnRulerArea() {
      return [
        new TimelineListViewMenuContent(
          (this.isLoopEnabled)? 'Disable loop' : 'Enable loop',
          () => { this.$_emitUpdateIsLoopEnabled(!this.isLoopEnabled) },
          false,
        ),
        new TimelineListViewMenuContent(
          (this.$data.$_followPlayBarFlag)? 'Unfollow play bar' : 'Follow play bar',
          this.$_toggleFollowPlayBarFlag,
          false,
        ),
        new TimelineListViewMenuContent(
          'Clear marker',
          this.clearMarker,
          !this.$_isMarkerSet,
        ),
        new TimelineListViewMenuContent(
          'Set loop by marker',
          this.setLoopByMarker,
          !this.$_isMarkerSet,
        ),
      ];
    },

    $_menuContentsForTimelineListOnSelectedSegment() {
      {
        let singleDataTypeOfSelectedTimelineSegments = getSingleDataTypeOfSelectedTimelineSegments.call(this);
        return [
          new TimelineListViewMenuContent(
            'Edit segment',
            async () => { await this.invokeActionOnSelectedTimelineSegments('editSegment') },
            (this.$_onlyOneSelectedTimelineSegmentId === undefined),
          ),
          new TimelineListViewMenuContent(
            'Copy segment data',
            async () => { await this.invokeActionOnSelectedTimelineSegments('setCopySource') },
            (this.$_onlyOneSelectedTimelineSegmentId === undefined),
          ),
          new TimelineListViewMenuContent(
            'Paste segment data',
            this.copySegmentsFromCopySource,
            false,
          ),
          new TimelineListViewMenuContent(
            'Move segments',
            async () => { this.moveTimelineSegments(this.selectedTimelineSegmentIds, singleDataTypeOfSelectedTimelineSegments) },
            (singleDataTypeOfSelectedTimelineSegments === undefined),
          ),
          new TimelineListViewMenuContent(
            'Merge segments',
            async () => { await this.invokeActionOnSelectedTimelineSegments('mergeSegment') },
            !isMultipleSegmentsInAnyTimelineDataSelected.call(this),
          ),
          new TimelineListViewMenuContent(
            'Lock segment',
            async () => { await this.invokeActionOnSelectedTimelineSegments('lock') },
            false,
          ),
          new TimelineListViewMenuContent(
            'Unlock segment',
            async () => { await this.invokeActionOnSelectedTimelineSegments('unlock') },
            false,
          ),
          new TimelineListViewMenuContent(
            'Set loop',
            async () => { await this.invokeActionOnSelectedTimelineSegments('setLoop') },
            false,
          ),
          new TimelineListViewMenuContent(
            'Set marker',
            async () => { await this.invokeActionOnSelectedTimelineSegments('setMarker') },
            false,
          ),
        ];
      }

      function isMultipleSegmentsInAnyTimelineDataSelected() {
        let segmentIdsMemo = {};
        for (let selectedTimelineSegmentId of this.selectedTimelineSegmentIds) {
          let timelineDataId = selectedTimelineSegmentId.timelineDataId;
          let segmentId = selectedTimelineSegmentId.segmentId;
          if (Object.keys(segmentIdsMemo).includes(timelineDataId)) {
            if (!segmentIdsMemo[timelineDataId].includes(segmentId)) return true;
          } else {
            segmentIdsMemo[timelineDataId] = [ segmentId ];
          }
        }
        return false;
      }

      function getSingleDataTypeOfSelectedTimelineSegments() {
        let singleTimelineSegmentDataType = undefined;
        for (let selectedTimelineSegmentId of this.selectedTimelineSegmentIds) {
          let timelineDataId = selectedTimelineSegmentId.timelineDataId;
          let timelineSegmentDataType = this.visibleTimelineDataSet[timelineDataId].segmentDataType;
          if (singleTimelineSegmentDataType === undefined) {
            singleTimelineSegmentDataType = timelineSegmentDataType;
          } else if (singleTimelineSegmentDataType !== timelineSegmentDataType) {
            return undefined;
          }
        }
        return singleTimelineSegmentDataType;
      }
    },

    $_menuContentsForTimelineList() {
      return Object.values(viewMode).map(viewModeTitle => new TimelineListViewMenuContent(viewModeTitle, this.$_setViewMode, false));
    },

    $_timeScrollBarTimeResolution() {
      let timelineScrollAreaWidthPxExcludingScrollBar = this.$_timelineCanvasWidthPx - this.$_timeScrollBarDurationPx;
      let timelineScrollAreaDurationExcludingScrollBar = this.$_timelineViewDurationWithMarginMax.subtract(this.$_timelineViewDuration);
      if (timelineScrollAreaDurationExcludingScrollBar.isEqualTo(TimeValue.zero)) return Infinity;
      return timelineScrollAreaWidthPxExcludingScrollBar / timelineScrollAreaDurationExcludingScrollBar.msec;
    },

    $_visibleTimelineDataIdAtMousedown() {
      if (this.$_timelineCanvasLocalYAtMousedown === undefined) return undefined;
      let mousedownVisibleTimelineDataIdx = this.$_timelineCanvasLocalYToVisibleTimelineDataIdx(this.$_timelineCanvasLocalYAtMousedown)
      if (mousedownVisibleTimelineDataIdx === undefined) return undefined;
      return this.visibleTimelineDataIdxToId[mousedownVisibleTimelineDataIdx];
    },

    $_numVisibleTimelines() {
      return Object.keys(this.visibleTimelineDataSet).length;
    },

    $_timelineSegmentDomRects() {
      {
        let timelineSegmentDomRects = {};
        let timelineDataIdArray = this.visibleTimelineDataIdxToId;
        let timelineDataArray = timelineDataIdArray.map(timelineDataId => this.visibleTimelineDataSet[timelineDataId]);
        let numTimelineData = timelineDataIdArray.length;
        for(let timelineDataIdx = 0; timelineDataIdx < numTimelineData; timelineDataIdx++) {
          let timelineDataId = timelineDataIdArray[timelineDataIdx];
          let timelineData = timelineDataArray[timelineDataIdx];
          timelineSegmentDomRects[timelineDataId] = {};
          for (let [ segmentId, segment ] of Object.entries(timelineData.segments)) {
            let beginTime = (segment.begin === null)? this.$_timelineViewBeginMinIncludingMargin : segment.begin;
            let endTime = (segment.end === null)? this.timelineViewEndMax : segment.end;
            timelineSegmentDomRects[timelineDataId][segmentId] = generateSegmentDomRect.call(this, timelineDataIdx, beginTime, endTime);
          }
        }
        return timelineSegmentDomRects;
      }

      function generateSegmentDomRect(timelineDataIdx, beginTime, endTime) {
        let timelineTopOffsetPx = this.$_timelineHeightPx * timelineDataIdx + this.$data.$_verticalOffsetPx + timelineSegmentVerticalMarginPx;
        let beginTimelineViewOffset = beginTime.getOffsetFrom(this.$data.$_timelineViewBegin);
        let scaledBeginTimelineViewOffsetPx = this.$_scaledTimeToPx(beginTimelineViewOffset);
        let duration = endTime.getOffsetFrom(beginTime);
        let scaledDurationPx = this.$_scaledTimeToPx(duration);
        let timelineSegmentHeightPx = this.$_timelineHeightPx - timelineSegmentVerticalMarginPx * 2;
        return new DOMRect(
          scaledBeginTimelineViewOffsetPx,
          timelineTopOffsetPx,
          scaledDurationPx,
          timelineSegmentHeightPx,
        );
      }
    },

    $_timelineViewDurationMax() {
      return this.timelineViewEndMax.getOffsetFrom(this.timelineViewBeginMin);
    },

    $_timelineViewDurationWithMarginMax() {
      return this.timelineViewEndMax.getOffsetFrom(this.$_timelineViewBeginMinIncludingMargin);
    },

    $_timeScrollBarDurationPx() {
      let timeScrollBarDurationPx = this.$_timelineCanvasWidthPx * this.$_timelineViewDuration.msec / this.$_timelineViewDurationWithMarginMax.msec;
      return (timeScrollBarDurationPx > timeScrollBarDurationPxMin)? timeScrollBarDurationPx : timeScrollBarDurationPxMin;
    },

    $_timeScrollBarDomRect() {
      let timelineViewBeginOffsetFromMin = this.$data.$_timelineViewBegin.getOffsetFrom(this.$_timelineViewBeginMinIncludingMargin);
      let timeScrollBarOffsetPx = (this.$_timeScrollBarTimeResolution !== Infinity)? this.$_scaledTimeToScrollBarPx(timelineViewBeginOffsetFromMin) : 0;
      return new DOMRect(
        timeScrollBarOffsetPx,
        0,
        this.$_timeScrollBarDurationPx,
        this.$data.$_timelineScrollBarWidthPx,
      );
    },

    $_timelineCanvasContainerClass() {
      let classNames = [];
      switch (this.$data.$_currentViewMode) {
      case viewMode.normal:
        classNames.push('timeline-canvas-view-mode-normal');
        break;
      case viewMode.select:
        classNames.push('timeline-canvas-view-mode-select');
        break;
      case viewMode.create:
        classNames.push('timeline-canvas-view-mode-create');
        break;
      case viewMode.divide:
        classNames.push('timeline-canvas-view-mode-divide');
        break;
      case viewMode.position:
        classNames.push('timeline-canvas-view-mode-position');
        break;
      }

      if (this.$_isDraggingSegments) {
        classNames.push('mouse-cursor-on-timeline-selected-segment');
      } else if (this.$_isMouseCursorOnScrollBarArea) {
        classNames.push('mouse-cursor-on-scroll-bar-area');
      } else if (this.$_isMouseCursorOnRulerArea) {
        classNames.push('mouse-cursor-on-ruler-area');
      } else if (this.$_isMouseCursorOnVisibleTimeline){
        classNames.push('mouse-cursor-on-timeline');
        if ((this.$_timelineSegmentIdWithInfoAtMousemove !== undefined) && !this.$_isMouseEventStarted) {
          let timelineSegmentIdAtMouseCursor = this.$_timelineSegmentIdWithInfoAtMousemove.timelineSegmentId;
          if (this.$_isTimelineSegmentIdSelected(timelineSegmentIdAtMouseCursor)) {
            let isMouseCursorOnLeftEdge = this.$_timelineSegmentIdWithInfoAtMousemove.isOnLeftEdge;
            let isMouseCursorOnRightEdge = this.$_timelineSegmentIdWithInfoAtMousemove.isOnRightEdge;
            if (isMouseCursorOnLeftEdge || isMouseCursorOnRightEdge) {
              classNames.push('mouse-cursor-on-timeline-selected-segment-edge');
            } else {
              classNames.push('mouse-cursor-on-timeline-selected-segment');
            }
          } else {
            classNames.push('mouse-cursor-on-timeline-segment');
          }
        }
      }
      return classNames;
    },

    $_isMouseMode: {
      get()            { return this.isMouseMode },
      set(isMouseMode) { this.$emit('update:is-mouse-mode', isMouseMode) },
    },

    $_isSnapEnabled: {
      get()              { return this.isSnapEnabled },
      set(isSnapEnabled) { this.$emit('update:is-snap-enabled', isSnapEnabled) },
    },

    $_reversedSortedVisibleSegmentIdxToIdMaps() {
      let reversedSortedVisibleSegmentIdxToIdMaps = new Map();
      for (let timelineDataId of this.visibleTimelineDataIdxToId) {
        reversedSortedVisibleSegmentIdxToIdMaps.set(timelineDataId, Array.from(this.sortedVisibleSegmentIdxToIdMaps.get(timelineDataId)).reverse());
      }
      return reversedSortedVisibleSegmentIdxToIdMaps;
    },
  },

  created() {
    materialDesignFont.load()
      .then(
        fontFace => document.fonts.add(fontFace),
        reason => console.error(reason),
      );
    this.$_setViewMode(viewMode.normal);
  },

  mounted() {
    this.$data.$_timelineCanvasContainerResizeObserver.observe(this.$refs.timelineCanvasContainer);
    this.$data.$_requestAnimationFrameCallbackId = window.requestAnimationFrame(this.$_draw);
    let intervalId = window.setInterval(
      () => {
        if (this.$el.clientWidth > 0) {
          this.$_initializeView();
          window.clearInterval(intervalId);
        }
      },
      100,
    )
  },

  destroyed() {
    this.$data.$_timelineCanvasContainerResizeObserver.disconnect();
    window.cancelAnimationFrame(this.$data.$_requestAnimationFrameCallbackId);
    document.fonts.delete(materialDesignFont);
  },

  inject: [
    'removeTimelineData',
    'renameTimelineData',
    'generateNewTimelineData',
    'generateNewTimelineDataFromExistingTimelines',
    'duplicateTimelineData',
    'hideTimelineData',
    'getTimelineDataImmutableReason',
    'moveTimelineSegments',
    'incrementVisibleTimelineDataIdx',
    'seek',
    'setMarker',
    'clearMarker',
    'setLoopFullDuration',
    'setLoopByMarker',
    'createSegment',
    'divideSegment',
    'generateEmptySegment',
    'invokeActionOnSelectedTimelineSegments',
    'importTimelineDataFromExistingTimelines',
    'selectTimelineSegments',
    'clearSelectedTimelineSegments',
    'copySegmentsFromCopySource',
    'atomicChanges',
    'setNewSegment',
    'setSegment',
    'registerFooterMessage',
  ],

  provide() {
    return {
      pxToScaledTime: this.$_pxToScaledTime,
      scaledTimeToPx: this.$_scaledTimeToPx,
      timeToTimelineCanvasLocalX: this.$_timeToTimelineCanvasLocalX,
      timelinePositionToTimelineCanvasLocalY: this.$_timelinePositionToTimelineCanvasLocalY,
      timelineCanvasLocalYToVisibleTimelineDataIdx: this.$_timelineCanvasLocalYToVisibleTimelineDataIdx,
    };
  },

  methods: {
    /* public */
    selectTimelineSegment(timelineSegmentId) {
      if (this.$_isTimelineSegmentVisible(timelineSegmentId)) {
        this.$_selectTimelineSegmentCore(timelineSegmentId);
      }
    },

    /* private */
    async $_onMousedown(event) {
      if (this.$_isMouseEventStarted) {
        this.onMouseup(event);
        return;
      }
      this.$data.$_isInSingleClickTimeRange = true;
      window.setTimeout(() => { this.$data.$_isInSingleClickTimeRange = false }, singleClickDurationMsecMax);
      this.$_updateMouseEventContext(event);
      if (mouseEventUtils.isAnyMouseButtonPressed(event)) {
        let [ timelineCanvasLocalX, timelineCanvasLocalY ] = this.$_eventToTimelineCanvasLocalXY(event);
        if (this.$_isMouseCursorOnScrollBarArea) {
          let scrollBarLocalX = timelineCanvasLocalX;
          let scrollBarLocalY = timelineCanvasLocalY - this.$_timelineCanvasHeightPx;
          if (utils.isInRect(this.$_timeScrollBarDomRect, scrollBarLocalX, scrollBarLocalY)) {
            this.$data.$_timelineCanvasLocalXAtMousedownOnScrollBar = timelineCanvasLocalX;
            this.$data.$_timelineViewBeginAtMousedownOnScrollBar = this.$data.$_timelineViewBegin.clone();
            this.$data.$_isMousedownOnScrollBar = true;
          } else {
            let nextTimelineViewCenterScrollBarOffsetPx = scrollBarLocalX;
            let nextTimelineViewBeginScrollBarOffsetPx = nextTimelineViewCenterScrollBarOffsetPx - (this.$_timeScrollBarDurationPx / 2);
            let nextTimelineViewBegin = this.$_timelineViewBeginMinIncludingMargin.add(this.$_scrollBarPxToScaledTime(nextTimelineViewBeginScrollBarOffsetPx));
            this.$_setTimelineViewBegin(nextTimelineViewBegin);
          }
        } else if (this.$_isMousemoveOnTimelineCanvas) {
          let timelineCanvasClampedLocalX = this.$_clampTimelineCanvasLocalX(timelineCanvasLocalX);
          let timelineCanvasClampedLocalY = this.$_clampTimelineCanvasLocalY(timelineCanvasLocalY);
          let timelineCanvasLocalCoordsAtMousedown = new TimelineCanvasLocalCoords(timelineCanvasClampedLocalX, timelineCanvasClampedLocalY);
          let edgeInfoAtMousedown = new EdgeInfo(timelineCanvasLocalCoordsAtMousedown, this.$_timelineCanvasWidthPx, this.$_timelineCanvasContainerHeightPx);
          this.$data.$_isMousedownOnRulerArea = this.$_isMouseCursorOnRulerArea;
          this.$data.$_edgeInfoAtMousedown = edgeInfoAtMousedown;
          this.$data.$_isAutoScrollPending = true;
          this.$data.$_timelineSegmentIdWithInfoAtMousedown = this.$_timelineSegmentIdWithInfoAtMousemove;
          let timelinePosition = this.$_timelineCanvasLocalYToTimelinePosition(timelineCanvasClampedLocalY);
          let time = this.$_timelineCanvasLocalXToTime(timelineCanvasClampedLocalX);
          let snappedTimelineContainerClampedLocalX = this.$_getSnappedTimelineCanvasLocalX(timelineCanvasClampedLocalX);
          let snappedTime = this.$_timelineCanvasLocalXToTime(snappedTimelineContainerClampedLocalX);
          this.$data.$_timeAndTimelinePositionAtMousedown = new TimeAndTimelinePosition(time, snappedTime, timelinePosition);
        }
        this.$data.$_firstMouseButtonAtMousedown = mouseEventUtils.getMouseButton(event);
      }
    },

    /* public */
    onMousemove(event) {
      if (this.$_isPresumableAsClick) return;
      this.$_updateMouseEventContext(event);
      this.$refs.timelineTitleAndFooterContainer.onMousemove(event);
      let isMouseEventFinished = mouseEventUtils.isNoMouseButtonPressed(event);
      if (this.$_isMouseEventStarted && isMouseEventFinished) {
        this.onMouseup(event);
      }
    },

    onMouseup(event) {
      this.$_updateMouseEventContext(event);
      this.$refs.timelineTitleAndFooterContainer.onMouseup();
      /* Wait selection state updated */
      this.$nextTick(() => { 
        if (this.$_isMouseEventStarted) {
          let mouseButtonAtMouseup = mouseEventUtils.getMouseButton(event);
          if ((mouseButtonAtMouseup === mouseButtonEnum.main) && event.ctrlKey) mouseButtonAtMouseup = mouseButtonEnum.sub;
          if (this.$data.$_firstMouseButtonAtMousedown === mouseButtonAtMouseup) {
            if (this.$data.$_timeAndTimelinePositionAtMousedown !== undefined) {
              if ((this.$_isPresumableAsClick) || (this.$data.$_timeAndTimelinePositionAtMousemove.isEqualTo(this.$data.$_timeAndTimelinePositionAtMousedown))) {
                this.$_onClickFixed(event.shiftKey, mouseButtonAtMouseup);
              } else {
                this.$_onDragFixed(this.$data.$_timeAndTimelinePositionAtMousemove, event.shiftKey);
              }
              if (mouseButtonAtMouseup === mouseButtonEnum.sub) {
                this.$_openTimelineListMenu(event);
              }
            }
          }
          this.$_resetOnMouseEvent();
        }
      });
    },

    onScroll(event) {
      let [ fixedTimelineCanvasLocalX, fixedTimelineCanvasLocalY ] = this.$_eventToTimelineCanvasLocalXY(event);
      if (fixedTimelineCanvasLocalY < 0) return false;
      if (this.isMouseMode) {
        let inverted = ((event.deltaY + event.deltaX) > 0);
        let l2norm = Math.sqrt(Math.pow(event.deltaX, 2) + Math.pow(event.deltaY, 2));
        if (event.ctrlKey) {
          if (event.shiftKey) {
            let amount = ((inverted)? -1 : 1) * utils.clamp(Math.log10(l2norm) * 0.8 - 1, 0, 2);
            if (event.altKey) {
              this.$_setWaveformScale(this.$data.$_waveformScale + amount);
            } else {
              this.$_updateVerticalOffsetPxAndTimelinePositionResolution(
                fixedTimelineCanvasLocalY,
                this.$data.$_timelinePositionResolution + amount,
              );
            }
          } else {
            let amount = utils.clamp(((l2norm / 5) + 1), 1, 2);
            let scale = (inverted)? (1 / amount) : amount;
            if (fixedTimelineCanvasLocalX < 0) {
              fixedTimelineCanvasLocalX = 0;
            }
            this.$_updateTimelineViewBeginAndTimeResolution(
              fixedTimelineCanvasLocalX,
              this.$data.$_timeResolution * scale,
            );
          }
        } else {
          let amount = utils.clamp(l2norm / 5, 0, 2);
          if (event.shiftKey) {
            this.$_stepTimeOffset(((inverted)? 1 : -1) * amount);
          } else {
            this.$_stepVerticalOffset(((inverted)? -1 : 1) * amount);
          }
        }
      } else {
        if (event.ctrlKey) {
          let amountY = utils.clamp(((Math.abs(event.deltaY) / 10) + 1), 1, 2);
          let scale = (event.deltaY > 0)? (1 / amountY) : amountY;
          if (event.shiftKey) {
            if (event.altKey) {
              this.$_setWaveformScale(this.$data.$_waveformScale * scale);
            } else {
              this.$_updateVerticalOffsetPxAndTimelinePositionResolution(
                fixedTimelineCanvasLocalY,
                this.$data.$_timelinePositionResolution * scale,
              );
            }
          } else {
            if (fixedTimelineCanvasLocalX < 0) {
              fixedTimelineCanvasLocalX = 0;
            }
            this.$_updateTimelineViewBeginAndTimeResolution(
              fixedTimelineCanvasLocalX,
              this.$data.$_timeResolution * scale,
            );
          }
        } else {
          let amountX = utils.clamp(event.deltaX / 5, -2, 2);
          let amountY = utils.clamp(event.deltaY / 5, -2, 2);
          this.$_stepTimeOffset(amountX);
          this.$_stepVerticalOffset(-amountY);
        }
      }
      this.$_updateMouseEventContext(event);
      return true;
    },

    onKeydown(event) {
      {
        let withShift = event.shiftKey;
        let withCtrl = event.ctrlKey;
        let withAlt = event.altKey;

        if (document.activeElement !== document.body) return false;

        if (this.$_isMouseEventStarted) {
          switch (event.code) {
          case 'Escape':
            this.$_resetOnMouseEvent();
            return true;
          }
        }

        if (this.$_isAnyTimelineRealtimeSegmentCreationTarget) {
          switch (event.code) {
          case 'Escape':
            if (this.$data.$_isRealtimeSegmentOpen) {
              this.clearMarker();
            } else {
              clearRealtimeSegmentCreationTarget.call(this);
            }
            return true;
          }
        }

        switch (this.$data.$_currentViewMode) {
        case viewMode.select:
          if (onKeydownAtSelectMode.call(this, event, withShift)) return true;
          break;
        case viewMode.position:
          if (onKeydownAtPositionEditMode.call(this, event, withShift, withAlt)) return true;
          break;
        case viewMode.create:
          if (onKeydownAtCreateMode.call(this, event)) return true;
          break;
        case viewMode.divide:
          if (onKeydownAtDevideMode.call(this, event)) return true;
          break;
        }

        return onKeydownCommon.call(this, event, withShift, withCtrl, withAlt);
      }

      function onKeydownCommon(event, withShift, withCtrl, withAlt) {
        switch (event.code) {
        case 'ArrowRight':
          if (withShift) {
            if (this.$_isAnyTimelineSegmentIdSelected) {
              stepTimeResolutionByLastSelectedTimelineSegment.call(this, false);
            } else {
              stepTimeResolutionByFixedTime.call(this, false, this.$data.$_timelineViewBegin);
            }
          } else {
            this.$_stepTimeOffset(1);
          }
          return true;
        case 'ArrowLeft':
          if (withShift) {
            if (this.$_isAnyTimelineSegmentIdSelected) {
              stepTimeResolutionByLastSelectedTimelineSegment.call(this, true);
            } else {
              stepTimeResolutionByFixedTime.call(this, true, this.$data.$_timelineViewBegin);
            }
          } else {
            this.$_stepTimeOffset(-1);
          }
          return true;
        case 'ArrowUp':
          if (withShift) {
            if (withAlt) {
              stepWaveformScale.call(this, false);
            } else {
              stepPositionResolution.call(this, false);
            }
          } else {
            this.$_stepVerticalOffset(1);
          }
          return true;
        case 'ArrowDown':
          if (withShift) {
            if (withAlt) {
              stepWaveformScale.call(this, true);
            } else {
              stepPositionResolution.call(this, true);
            }
          } else {
            this.$_stepVerticalOffset(-1);
          }
          return true;
        case 'Home':
          if (this.$_isAnyTimelineSegmentIdSelected) {
            selectFirstSegment.call(this, false);
          } else {
            this.$_setTimelineViewBegin(this.$_timelineViewBeginMinIncludingMargin);
          }
          return true;
        case 'End':
          if (this.$_isAnyTimelineSegmentIdSelected) {
            selectFirstSegment.call(this, true);
          } else {
            this.$_setTimelineViewBegin(this.timelineViewEndMax.subtract(this.$_timelineViewDuration));
          }
          return true;
        case 'PageUp':
          this.$_stepPageTimeOffset(true);
          return true;
        case 'PageDown':
          this.$_stepPageTimeOffset(false);
          return true;
        case 'Enter':
          if (this.$_isAnyTimelineRealtimeSegmentCreationTarget) {
            if (this.isVideoPlaying) {
              if (this.$data.$_isRealtimeSegmentOpen) {
                this.$_recordRealtimeSegmentEnd();
              } else {
                this.$_recordRealtimeSegmentBegin();
              }
              return true;
            }
          } else {
            if (this.$_isAnyTimelineSegmentIdSelected) {
              if (withShift) {
                this.invokeActionOnSelectedTimelineSegments('general');
              } else {
                this.invokeActionOnSelectedTimelineSegments('editSegment');
              }
              return true;
            }
          }
          break;
        case 'Delete':
        case 'Backspace':
          if (withShift) {
            this.invokeActionOnSelectedTimelineSegments('deleteSegment');
          } else {
            this.invokeActionOnSelectedTimelineSegments('clearSegment');
          }
          return true;
        case 'Escape':
          if (this.$_isMarkerSet) {
            this.clearMarker();
            return true;
          }
          if (this.isLoopEnabled) {
            this.$_emitUpdateIsLoopEnabled(false);
            return true;
          }
          break;
        case 'KeyC':
          if (withCtrl) {
            this.invokeActionOnSelectedTimelineSegments('setCopySource');
            return true;
          } else {
            if (!withShift) {
              this.$_setViewMode(viewMode.create);
              return true;
            }
          }
          break;
        case 'KeyV':
          if (withCtrl & !withShift) {
            this.copySegmentsFromCopySource();
            return true;
          }
          break;
        case 'KeyD':
          if (withShift) {
            return divideSelectedSegmentsAtPlayTime.call(this);
          } else {
            if (!withCtrl) {
              this.$_setViewMode(viewMode.divide);
              return true;
            }
          }
          break;
        case 'KeyP':
          if (!withCtrl && !withShift) {
            this.$_setViewMode(viewMode.position);
            return true;
          }
          break;
        case 'KeyL':
          if (withCtrl) {
            if (withShift) {
              this.invokeActionOnSelectedTimelineSegments('unlock');
            } else {
              this.invokeActionOnSelectedTimelineSegments('lock');
            }
          } else {
            if (withShift) {
              if (this.$_isAnyTimelineSegmentIdSelected) {
                this.invokeActionOnSelectedTimelineSegments('setLoop');
              } else if (this.$_isMarkerSet) {
                this.setLoopByMarker();
              } else {
                this.setLoopFullDuration();
              }
            } else {
              this.$_emitUpdateIsLoopEnabled(!this.isLoopEnabled);
            }
          }
          return true;
        case 'KeyF':
          this.$_toggleFollowPlayBarFlag();
          return true;
        case 'KeyM':
          if (withShift) {
            if (withCtrl) {
              if (withAlt) {
                this.invokeActionOnSelectedTimelineSegments('setExclusiveMarker');
              } else {
                this.invokeActionOnSelectedTimelineSegments('setMarker');
              }
            } else {
              this.invokeActionOnSelectedTimelineSegments('mergeSegment');
            }
            return true;
          }
          break;
        case 'KeyS':
          if (!withCtrl) {
            this.$_setViewMode(viewMode.select);
            return true;
          }
          break;
        case 'KeyN':
          if (this.$_isAnyTimelineSegmentIdSelected) {
            this.invokeActionOnSelectedTimelineSegments('addNote');
            return true;
          }
          break;
        }
        return false;
      }

      function onKeydownAtSelectMode(event, withShift) {
        switch (event.code) {
        case 'ArrowRight':
          if (!withShift) {
            this.selectNextSegment();
            return true;
          }
          break;
        case 'ArrowLeft':
          if (!withShift) {
            this.selectPreviousSegment();
            return true;
          }
          break;
        case 'ArrowUp':
          if (!withShift) {
            selectNearestSegmentInNextTimeline.call(this, true);
            return true;
          }
          break;
        case 'ArrowDown':
          if (!withShift) {
            selectNearestSegmentInNextTimeline.call(this, false);
            return true;
          }
          break;
        case 'Home':
          selectFirstSegment.call(this, false);
          return true;
        case 'End':
          selectFirstSegment.call(this, true);
          return true;
        case 'Escape':
          this.$_setViewMode(viewMode.normal);
          return true;
        }
        return false;
      }

      function onKeydownAtPositionEditMode(event, withShift, withAlt) {
        switch (event.code) {
        case 'ArrowRight':
          if (withShift) {
            if (withAlt) {
              if (this.$_isAnyTimelineSegmentIdSelected) {
                offsetPositionEditTargetTimelineSegmentBeginOrEnd.call(this, 1, TimelineSegmentDomRectsToDragWithInfo.edgeType.left);
                return true;
              }
            } else {
              stepTimeResolutionByFixedTime.call(this, false, this.$data.$_timelineViewBegin.add(this.$_timelineViewDuration.half));
              return true;
            }
          } else {
            if (withAlt) {
              if (this.$_isAnyTimelineSegmentIdSelected) {
                offsetPositionEditTargetTimelineSegmentBeginOrEnd.call(this, 1, TimelineSegmentDomRectsToDragWithInfo.edgeType.right);
                return true;
              }
            } else {
              this.selectNextSegment();
              return true;
            }
          }
          break;
        case 'ArrowLeft':
          if (withShift) {
            if (withAlt) {
              if (this.$_isAnyTimelineSegmentIdSelected) {
                offsetPositionEditTargetTimelineSegmentBeginOrEnd.call(this, -1, TimelineSegmentDomRectsToDragWithInfo.edgeType.left);
                return true;
              }
            } else {
              stepTimeResolutionByFixedTime.call(this, true, this.$data.$_timelineViewBegin.add(this.$_timelineViewDuration.half));
              return true;
            }
          } else {
            if (withAlt) {
              if (this.$_isAnyTimelineSegmentIdSelected) {
                offsetPositionEditTargetTimelineSegmentBeginOrEnd.call(this, -1, TimelineSegmentDomRectsToDragWithInfo.edgeType.right);
                return true;
              }
            } else {
              this.selectPreviousSegment();
              return true;
            }
          }
          break;
        case 'ArrowUp':
          if (!withShift) {
            selectNearestSegmentInNextTimeline.call(this, true);
            return true;
          }
          break;
        case 'ArrowDown':
          if (!withShift) {
            selectNearestSegmentInNextTimeline.call(this, false);
            return true;
          }
          break;
        case 'Enter':
          if (this.$data.$_positionEditTargetTimelineSegmentId !== undefined) {
            this.$_fixPositionEditTargetTimelineSegment();
          }
          return true;
        case 'Escape':
          this.$_setViewMode(viewMode.normal);
          return true;
        }
        return false;
      }

      function onKeydownAtCreateMode(event) {
        switch (event.code) {
        case 'Escape':
          this.$_setViewMode(viewMode.normal);
          return true;
        }
        return false;
      }

      function onKeydownAtDevideMode(event) {
        switch (event.code) {
        case 'Escape':
          this.$_setViewMode(viewMode.normal);
          return true;
        }
        return false;
      }

      function divideSelectedSegmentsAtPlayTime() {
        let selectedTimelineSegmentIdsAtPlayTime = [];
        for (let selectedTimelineSegmentId of this.selectedTimelineSegmentIds) {
          let selectedSegment = this.visibleTimelineDataSet.getSegment(selectedTimelineSegmentId);
          if (selectedSegment.isInRange(this.playTime)) {
            selectedTimelineSegmentIdsAtPlayTime.push(selectedTimelineSegmentId);
          }
        }
        if (selectedTimelineSegmentIdsAtPlayTime.length > 0) {
          this.atomicChanges(
            'dividing segments at play time',
            'Divided segments at play time.',
            () => {
              for (let selectedTimelineSegmentIdAtPlayTime of selectedTimelineSegmentIdsAtPlayTime) {
                this.divideSegment(selectedTimelineSegmentIdAtPlayTime, this.playTime);
              }
            },
          );
          return true;
        } else {
          return false;
        }
      }

      function stepTimeResolutionByLastSelectedTimelineSegment(inverted) {
        let lastSelectedSegment = this.visibleTimelineDataSet.getSegment(this.$_lastSelectedTimelineSegmentId);
        let fixedTime = (lastSelectedSegment.begin === null)? this.timelineViewBeginMin : lastSelectedSegment.begin;
        let fixedTimelineViewOffsetPx = this.$_clampTimelineCanvasLocalX(this.$_scaledTimeToPx(fixedTime.getOffsetFrom(this.$data.$_timelineViewBegin)));
        stepTimeResolutionByFixedTimelineViewOffsetPx.call(this, inverted, fixedTimelineViewOffsetPx);
      }

      function stepTimeResolutionByFixedTime(inverted, fixedTime) {
        if (!this.$_isTimeInView(fixedTime)) {
          this.$_setTimelineViewCenter(fixedTime);
        }
        let fixedTimelineViewOffsetPx = this.$_scaledTimeToPx(fixedTime.getOffsetFrom(this.$data.$_timelineViewBegin));
        stepTimeResolutionByFixedTimelineViewOffsetPx.call(this, inverted, fixedTimelineViewOffsetPx);
      }

      function stepTimeResolutionByFixedTimelineViewOffsetPx(inverted, fixedTimelineViewOffsetPx) {
        let amount = (inverted)? 0.8 : 1.25;
        this.$_updateTimelineViewBeginAndTimeResolution(
          fixedTimelineViewOffsetPx,
          this.$data.$_timeResolution * amount,
        );
      }

      function stepPositionResolution(inverted) {
        let fixedTimelineCanvasLocalY = undefined;
        if (this.$_lastSelectedTimelineSegmentId !== undefined) {
          let lastSelectedTimelineDataId = this.$_lastSelectedTimelineSegmentId.timelineDataId;
          let lastSelectedSegmentId = this.$_lastSelectedTimelineSegmentId.segmentId;
          let lastSelectedTimelineSegmentDomRect = this.$_timelineSegmentDomRects[lastSelectedTimelineDataId][lastSelectedSegmentId];
          fixedTimelineCanvasLocalY = this.$_clampTimelineCanvasLocalY(lastSelectedTimelineSegmentDomRect.y);
        } else {
          fixedTimelineCanvasLocalY = rulerVerticalOffsetPx;
        }
        let scale = (inverted)? 0.8 : 1.25;
        this.$_updateVerticalOffsetPxAndTimelinePositionResolution(
          fixedTimelineCanvasLocalY,
          this.$data.$_timelinePositionResolution * scale,
        );
      }

      function stepWaveformScale(inverted) {
        this.$_setWaveformScale(this.$data.$_waveformScale * ((inverted)? 0.8 : 1.25))
      }

      function selectFirstSegment(inverted) {
        this.$data.$_followPlayBarFlag = false;
        let nextTimelineSegmentId = undefined;
        if (this.$_lastSelectedTimelineSegmentId === undefined) {
          nextTimelineSegmentId = this.$_findFirstVisibleTimelineSegmentId();
        } else {
          let nextTimelineDataId = this.$_lastSelectedTimelineSegmentId.timelineDataId;
          let sortedVisibleSegmentIdxToIdMap = this.sortedVisibleSegmentIdxToIdMaps.get(nextTimelineDataId);
          let numSegments = sortedVisibleSegmentIdxToIdMap.length;
          let firstSegmentIdx = sortedVisibleSegmentIdxToIdMap[(inverted)? (numSegments - 1) : 0];
          nextTimelineSegmentId = new TimelineSegmentId(nextTimelineDataId, firstSegmentIdx);
        }
        this.$_selectTimelineSegmentCore(nextTimelineSegmentId);
      }

      function selectNearestSegmentInNextTimeline(inverted) {
        this.$data.$_followPlayBarFlag = false;
        let nextTimelineSegmentId = undefined;
        if (this.$_lastSelectedTimelineSegmentId === undefined) {
          nextTimelineSegmentId = this.$_findFirstVisibleTimelineSegmentId();
        } else {
          let lastSelectedTimelineDataId = this.$_lastSelectedTimelineSegmentId.timelineDataId;
          let visibleTimelineDataIdxMax = this.visibleTimelineDataIdxToId.length - 1;
          let foundVisibleTimelineDataIdx = this.visibleTimelineDataIdxToId.findIndex((timelineDataId) => (lastSelectedTimelineDataId === timelineDataId));
          let visibleTimelineDataIdxTemp = foundVisibleTimelineDataIdx;
          while (nextTimelineSegmentId === undefined) {
            visibleTimelineDataIdxTemp += ((inverted)? -1 : 1);
            if ((visibleTimelineDataIdxTemp < 0) || (visibleTimelineDataIdxTemp > visibleTimelineDataIdxMax)) {
              nextTimelineSegmentId = this.$_lastSelectedTimelineSegmentId;
            } else {
              let visibleTimelineDataIdTemp = this.visibleTimelineDataIdxToId[visibleTimelineDataIdxTemp];
              let sortedVisibleSegmentIdxToIdMap = this.sortedVisibleSegmentIdxToIdMaps.get(visibleTimelineDataIdTemp);
              let numSegments = sortedVisibleSegmentIdxToIdMap.length;
              if (numSegments > 0) {
                let visibleSegmentIdTemp = sortedVisibleSegmentIdxToIdMap[0];
                for (let sortedSegmentIdx = 0; sortedSegmentIdx < numSegments; ++sortedSegmentIdx) {
                  let segmentId = sortedVisibleSegmentIdxToIdMap[sortedSegmentIdx];
                  let segment = this.visibleTimelineDataSet[visibleTimelineDataIdTemp].segments[segmentId];
                  if ((segment.begin !== null) && (segment.begin.isGreaterThan(this.$data.$_timelineSegmentNearestBaseTime))) break;
                  visibleSegmentIdTemp = segmentId;
                }
                nextTimelineSegmentId = new TimelineSegmentId(visibleTimelineDataIdTemp, visibleSegmentIdTemp);
              }
            }
          }
        }
        if (nextTimelineSegmentId !== undefined) {
          this.$_selectTimelineSegmentCore(nextTimelineSegmentId, { updatesNearestTimelineSegmentBase: false });
        }
      }

      function clearRealtimeSegmentCreationTarget() {
        this.$data.$_realtimeSegmentCreationTargetTimelineDataIds.splice(0);
      }

      function offsetPositionEditTargetTimelineSegmentBeginOrEnd(offsetPx, edgeType) {
        if (this.$data.$_positionEditTargetTimelineSegmentId === undefined) {
          this.$_initializePositionEditTargetTimelineSegment(this.$_lastSelectedTimelineSegmentId);
        }

        let offsetTime = this.$_pxToScaledTime(offsetPx).floor();
        let offsetPositionBegin = this.$data.$_positionEditTargetTimelineSegmentBegin;
        let offsetPositionEnd = this.$data.$_positionEditTargetTimelineSegmentEnd;
        switch(edgeType) {
        case TimelineSegmentDomRectsToDragWithInfo.edgeType.left:
          if (offsetPositionBegin !== null) {
            offsetPositionBegin.addSelf(offsetTime);
            if (offsetPositionBegin.isLessThan(TimeValue.zero)) {
              offsetPositionBegin.assign(TimeValue.zero);
            }
            if (offsetPositionEnd !== null) {
              if (offsetPositionEnd.getOffsetFrom(offsetPositionBegin).isLessThan(this.minimumSegmentDuration)) {
                offsetPositionBegin.assign(offsetPositionEnd.subtract(this.minimumSegmentDuration));
              }
            }
            this.$_setTimelineViewCenter(offsetPositionBegin);
          }
          break;
        case TimelineSegmentDomRectsToDragWithInfo.edgeType.right:
          if (offsetPositionEnd !== null) {
            offsetPositionEnd.addSelf(offsetTime);
            if (offsetPositionEnd.isLessThan(TimeValue.zero)) {
              offsetPositionEnd.assign(TimeValue.zero);
            }
            if (offsetPositionBegin !== null) {
              if (offsetPositionEnd.getOffsetFrom(offsetPositionBegin).isLessThan(this.minimumSegmentDuration)) {
                offsetPositionEnd.assign(offsetPositionBegin.add(this.minimumSegmentDuration));
              }
            }
            this.$_setTimelineViewCenter(offsetPositionEnd);
          }
          break;
        }
        this.setMarker(offsetPositionBegin, offsetPositionEnd);
        this.setLoopByMarker();

        if (this.isVideoPlaying) {
          switch(edgeType) {
          case TimelineSegmentDomRectsToDragWithInfo.edgeType.left:
            this.seek(offsetPositionBegin);
            break;
          case TimelineSegmentDomRectsToDragWithInfo.edgeType.right:
            this.seek(offsetPositionEnd
              .subtract(seekMarginTimeOnEndOfSegmentPositionChanged)
              .clampTo(offsetPositionBegin, offsetPositionEnd));
            break;
          }
        }
      }
    },

    selectPreviousSegment() {
      this.$data.$_followPlayBarFlag = false;
      let firstSelectedTimelineSegmentId = this.$_findFirstTimelineSegmentId(this.selectedTimelineSegmentIds);
      if (firstSelectedTimelineSegmentId === undefined) {
        let firstVisibleTimelineSegmentId = this.$_findFirstVisibleTimelineSegmentId();
        if (firstVisibleTimelineSegmentId !== undefined) {
          this.$_selectTimelineSegmentCore(firstVisibleTimelineSegmentId);
        }
      } else {
        this.$_visuallyOffsetTimelineSegmentId(firstSelectedTimelineSegmentId, -1);
      }
    },

    selectNextSegment() {
      this.$data.$_followPlayBarFlag = false;
      let lastSelectedTimelineSegmentId = this.$_findLastTimelineSegmentId(this.selectedTimelineSegmentIds);
      if (lastSelectedTimelineSegmentId === undefined) {
        let firstVisibleTimelineSegmentId = this.$_findFirstVisibleTimelineSegmentId();
        if (firstVisibleTimelineSegmentId !== undefined) {
          this.$_selectTimelineSegmentCore(firstVisibleTimelineSegmentId);
        }
      } else {
        this.$_visuallyOffsetTimelineSegmentId(lastSelectedTimelineSegmentId, 1);
      }
    },

    /* private */
    $_draw() {
      this.$refs.timelineBackgroundCanvas.draw();
      this.$refs.timelineSegmentCanvas.draw();
      this.$refs.timelineForegroundCanvas.draw();
      this.$refs.timelinePlayTimeBarCanvas.draw();
      this.$refs.timelineOverlayCanvas.draw();
      this.$refs.timeScrollBarCanvas.draw();
      this.$data.$_requestAnimationFrameCallbackId = window.requestAnimationFrame(this.$_draw);
    },

    $_onClickFixed(withShift, mouseButton) {
      let timelineCanvasLocalX = this.$_timelineCanvasLocalXAtMousedown;
      if (timelineCanvasLocalX > 0) {
        let timelineCanvasLocalY = this.$_timelineCanvasLocalYAtMousedown;
        if (timelineCanvasLocalY <= this.$_timelineCanvasHeightPx) {
          if (!this.$data.$_isMousedownOnRulerArea && this.$data.$_timelineSegmentIdWithInfoAtMousedown) {
            let snappedTimelineCanvasLocalX = this.$_getSnappedTimelineCanvasLocalX(timelineCanvasLocalX);
            let snappedTime = this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(snappedTimelineCanvasLocalX)).round();
            let timelineSegmentIdAtMousedown = this.$data.$_timelineSegmentIdWithInfoAtMousedown.timelineSegmentId;
            let retainsSelection = getRetainsSelection.call(this, withShift, mouseButton);
            switch (this.$data.$_currentViewMode) {
            case viewMode.normal:
            case viewMode.position:
            case viewMode.select:
              {
                if (this.$_isAnyTimelineSegmentIdSelected) {
                  if (withShift) {
                    if (this.$_isTimelineSegmentIdSelected(timelineSegmentIdAtMousedown)) {
                      this.invokeActionOnSelectedTimelineSegments('general');
                    }
                  } else {
                    if (this.$data.$_timelineSegmentIdAtLastClick !== undefined) {
                      if (this.$data.$_timelineSegmentIdAtLastClick.isSameAs(timelineSegmentIdAtMousedown)) {
                        if (this.$_onlyOneSelectedTimelineSegmentId !== undefined) {
                          if (this.$_onlyOneSelectedTimelineSegmentId.isSameAs(timelineSegmentIdAtMousedown)) {
                            this.invokeActionOnSelectedTimelineSegments('editSegment');
                          }
                        }
                      }
                    }
                    this.$data.$_timelineSegmentIdAtLastClick = timelineSegmentIdAtMousedown;
                    if (this.$data.$_doubleClickOnTimelineSegmentTimeout !== undefined) {
                      window.clearTimeout(this.$data.$_doubleClickOnTimelineSegmentTimeout);
                    }
                    this.$data.$_doubleClickOnTimelineSegmentTimeout = window.setTimeout(
                      () => {
                        this.$data.$_timelineSegmentIdAtLastClick = undefined;
                        this.$data.$_doubleClickOnTimelineSegmentTimeout = undefined;
                      },
                      doubleClickIntervalOnTimelineSegmentMsecMax,
                    );
                  }
                }
                switch (this.$data.$_currentViewMode) {
                case viewMode.position:
                  this.$_selectTimelineSegmentCore(timelineSegmentIdAtMousedown, { retainsSelection, retainsViewMode: true });
                  break;
                default:
                  this.$_selectTimelineSegmentCore(timelineSegmentIdAtMousedown, { retainsSelection });
                  break;
                }
              }
              break;
            case viewMode.divide:
              if (this.$data.$_timelineSegmentIdWithInfoAtMousedown !== undefined) {
                if (this.$_isTimelineSegmentIdSelected(timelineSegmentIdAtMousedown)) {
                  this.divideSegment(timelineSegmentIdAtMousedown, snappedTime);
                } else {
                  this.$_selectTimelineSegmentCore(timelineSegmentIdAtMousedown, { retainsSelection, retainsViewMode: true });
                }
              }
              break;
            }
          } else {
            if (this.$data.$_firstMouseButtonAtMousedown === mouseButtonEnum.main) {
              if (this.$data.$_isMousedownOnRulerArea) {
                this.clearMarker();
              }
              this.seek(this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(timelineCanvasLocalX)).round());
            }
            if (!withShift) {
              switch (this.$data.$_currentViewMode) {
              case viewMode.select:
              case viewMode.position:
                this.$_setViewMode(viewMode.normal);
              }
            }
          }
        }
      }

      function getRetainsSelection(withShift, mouseButton) {
        if (withShift) return true;
        if (
          this.$_isTimelineSegmentIdSelected(this.$_timelineSegmentIdWithInfoAtMousemove.timelineSegmentId) &&
          (mouseButton === mouseButtonEnum.sub)
        ) {
          return true;
        }
        return false;
      }
    },

    $_openTimelineListMenu(event) {
      {
        this.$refs.timelineListMenu.openMenu(event, getMenuContentsForTimelineList.call(this));
      }

      function getMenuContentsForTimelineList() {
        if (this.$_isMousemoveOnTimelineCanvas) {
          if (this.$_timelineSegmentIdWithInfoAtMousemove !== undefined) {
            return this.$_menuContentsForTimelineListOnSelectedSegment;
          } else if (this.$data.$_isMousedownOnRulerArea) {
            return this.$_menuContentsForTimelineListOnRulerArea;
          }
        }
        return this.$_menuContentsForTimelineList;
      }
    },

    $_onDragFixed(timeAndTimelinePositionAtMouseup, withShift) {
      {
        if (this.$data.$_isMousedownOnRulerArea) {
          if (this.$data.$_firstMouseButtonAtMousedown === mouseButtonEnum.main) {
            let [ x0, x1 ] = sort(
              this.$_timeToTimelineCanvasLocalX(this.$data.$_timeAndTimelinePositionAtMousedown.time),
              this.$_timeToTimelineCanvasLocalX(timeAndTimelinePositionAtMouseup.time),
            );
            let markerBegin = this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(x0)).round();
            let markerEnd = this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(x1)).round();
            if (markerBegin.isEqualTo(markerEnd)) {
              this.seek(markerBegin);
            } else {
              this.setMarker(markerBegin, markerEnd);
            }
          }
        } else {
          switch (this.$data.$_currentViewMode) {
          default:
            if (this.$_timelineSegmentDomRectsToDragWithInfo !== undefined) {
              this.$_offsetSegmentTimeByDrag(this.$_timelineSegmentDomRectsToDragWithInfo.edgeType);
            } else {
              if (!withShift) {
                this.clearSelectedTimelineSegments();
              }
              let [ x0, x1 ] = sort(
                this.$_timeToTimelineCanvasLocalX(this.$data.$_timeAndTimelinePositionAtMousedown.snappedTime),
                this.$_timeToTimelineCanvasLocalX(timeAndTimelinePositionAtMouseup.snappedTime),
              );
              let [ y0, y1 ] = sort(
                this.$_timelinePositionToTimelineCanvasLocalY(this.$data.$_timeAndTimelinePositionAtMousedown.timelinePosition),
                this.$_timelinePositionToTimelineCanvasLocalY(timeAndTimelinePositionAtMouseup.timelinePosition),
              );
              let dragRect = new DOMRect(x0, y0, x1 - x0, y1 - y0);
              let foundTimelineSegmentIds = findAllTimelineSegmentIdsInDomRect(dragRect, this.$_timelineSegmentDomRects);
              if (foundTimelineSegmentIds.length > 0) {
                let retainsViewMode = (this.$data.$_currentViewMode !== viewMode.normal);
                this.$_selectTimelineSegmentsCore(foundTimelineSegmentIds, { retainsViewMode: retainsViewMode, forcesToBeInTimelineView: false });
              } else {
                if (!withShift) {
                  if (this.$data.$_currentViewMode === viewMode.select) {
                    this.$_setViewMode(viewMode.normal);
                  }
                }
              }
            }
            break;
          case viewMode.create:
            if (this.$data.$_firstMouseButtonAtMousedown === mouseButtonEnum.main) {
              if (this.$_visibleTimelineDataIdAtMousedown !== undefined) {
                let timelineDataAtMousedown = this.visibleTimelineDataSet[this.$_visibleTimelineDataIdAtMousedown];
                if (!timelineDataAtMousedown.locked) {
                  let { begin, end } = getTimelineSegmentBeginAndEndOnCreateMode.call(this, timeAndTimelinePositionAtMouseup);
                  createNewSegment.call(this, this.$_visibleTimelineDataIdAtMousedown, begin, end, withShift)
                    .then(newTimelineSegmentId => {
                      if (newTimelineSegmentId === undefined) return;
                      this.$nextTick(() => { this.$_selectTimelineSegmentCore(newTimelineSegmentId, { retainsViewMode: true }) });
                    });
                }
              }
            }
            break;
          }
        }
      }

      function getTimelineSegmentBeginAndEndOnCreateMode(timeAndTimelinePositionAtMouseup) {
        if ((this.timelineMarker !== undefined) && this.timelineMarker.isInRange(this.$data.$_timeAndTimelinePositionAtMousedown.time)) {
          return {
            begin: this.timelineMarker.begin,
            end: this.timelineMarker.end,
          };
        } else {
          let [ x0, x1 ] = sort(
            this.$_timeToTimelineCanvasLocalX(this.$data.$_timeAndTimelinePositionAtMousedown.snappedTime),
            this.$_timeToTimelineCanvasLocalX(timeAndTimelinePositionAtMouseup.snappedTime),
          );
          return {
            begin: this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(x0)).round(),
            end: this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(x1)).round(),
          };
        }
      }

      async function createNewSegment(timelineSegmentId, begin, end, withShift) {
        if (withShift) {
          return this.generateEmptySegment(timelineSegmentId, begin, end);
        } else {
          return await this.createSegment(timelineSegmentId, begin, end);
        }
      }

      function sort(value1, value2) {
        return (value1 < value2)? [ value1, value2 ] : [ value2, value1 ];
      }

      function findAllTimelineSegmentIdsInDomRect(domRect, timelineSegmentDomRects) {
        let allTimelineSegmentIds = [];
        for (let [ timelineDataId, segmentDomRectsByTimelineDataId ] of Object.entries(timelineSegmentDomRects)) {
          for (let [ segmentId, timelineSegmentDomRect ] of Object.entries(segmentDomRectsByTimelineDataId)) {
            if (utils.areRectsOverwrapped(timelineSegmentDomRect, domRect)) {
              allTimelineSegmentIds.push(new TimelineSegmentId(timelineDataId, segmentId));
            }
          }
        }
        return allTimelineSegmentIds;
      }
    },

    $_offsetSegmentTimeByDrag(edgeType) {
      if (this.isAnySelectedTimelineSegmentImmutable) return;
      this.atomicChanges(
        'offsetting segments',
        'Offset segments.',
        () => {
          for (let timelineSegmentId of this.selectedTimelineSegmentIds) {
            let timelineData = this.visibleTimelineDataSet[timelineSegmentId.timelineDataId];
            let timelineSegment = this.visibleTimelineDataSet.getSegment(timelineSegmentId);
            let offsetTimelineSegment = timelineSegment.clone(false);
            if (timelineSegment.begin !== null) {
              switch (edgeType) {
              case TimelineSegmentDomRectsToDragWithInfo.edgeType.left:
              case TimelineSegmentDomRectsToDragWithInfo.edgeType.none:
                offsetTimelineSegment.assign({ begin: timelineSegment.begin.add(this.$data.$_segmentDragOffsetTime) });
                break;
              }
            }
            if (timelineSegment.end !== null) {
              switch (edgeType) {
              case TimelineSegmentDomRectsToDragWithInfo.edgeType.right:
              case TimelineSegmentDomRectsToDragWithInfo.edgeType.none:
                offsetTimelineSegment.assign({ end: timelineSegment.end.add(this.$data.$_segmentDragOffsetTime) });
                break;
              }
            }
            this.setSegment(
              timelineSegmentId,
              timelineData.segmentDataType,
              offsetTimelineSegment,
              'Offset segment.',
              'Offsetting segment',
            );
          }
        },
      );
    },
    
    $_eventToTimelineCanvasLocalXY(event) {
      if (this.$data.$_timelineCanvasContainerBoundingClientRect === undefined) return [ 0, 0 ];
      return [
        event.clientX - this.$data.$_timelineCanvasContainerBoundingClientRect.left,
        event.clientY - this.$data.$_timelineCanvasContainerBoundingClientRect.top,
      ];
    },

    $_setSegmentDragOffsetTime(segmentDragOffsetTime, edgeType) {
      {
        if (this.isAnySelectedTimelineSegmentImmutable || areAllSelectedTimelineSegmentsDurationInfinity.call(this)) {
          this.$data.$_segmentDragOffsetTime = TimeValue.zero;
          return;
        }
        let smallestBegin = getSmallestBeginInSelectedTimelineSegments.call(this);
        let largestEnd = getLargestEndInSelectedTimelineSegments.call(this);
        let smallestDuration = getSmallestDurationInSelectedTimelineSegments.call(this);
        switch (edgeType) {
        case TimelineSegmentDomRectsToDragWithInfo.edgeType.left:
          segmentDragOffsetTime = clampTimeOffsetOnLeftEdgeViaSmallestDuration.call(this, segmentDragOffsetTime, smallestDuration);
          segmentDragOffsetTime = clampTimeOffsetViaSmallestBegin.call(this, segmentDragOffsetTime, smallestBegin);
          break;
        case TimelineSegmentDomRectsToDragWithInfo.edgeType.right:
          segmentDragOffsetTime = clampTimeOffsetOnRightEdgeViaSmallestDuration.call(this, segmentDragOffsetTime, smallestDuration);
          segmentDragOffsetTime = clampTimeOffsetViaLargestEnd.call(this, segmentDragOffsetTime, largestEnd);
          break;
        case TimelineSegmentDomRectsToDragWithInfo.edgeType.none:
          segmentDragOffsetTime = clampTimeOffsetViaSmallestBegin.call(this, segmentDragOffsetTime, smallestBegin);
          segmentDragOffsetTime = clampTimeOffsetViaLargestEnd.call(this, segmentDragOffsetTime, largestEnd);
          break;
        }
        this.$data.$_segmentDragOffsetTime = segmentDragOffsetTime;
      }

      function getSmallestDurationInSelectedTimelineSegments() {
        let smallestDuration = this.$_timelineViewDurationMax;
        for (let timelineSegmentId of this.selectedTimelineSegmentIds) {
          let timelineSegment = this.visibleTimelineDataSet.getSegment(timelineSegmentId);
          if ((timelineSegment.begin !== null) && (timelineSegment.end !== null)) {
            let duration = timelineSegment.end.getOffsetFrom(timelineSegment.begin);
            if (duration.isLessThan(smallestDuration)) {
              smallestDuration = duration;
            }
          }
        }
        return smallestDuration;
      }

      function getSmallestBeginInSelectedTimelineSegments() {
        let smallestBegin = this.timelineViewEndMax;
        for (let timelineSegmentId of this.selectedTimelineSegmentIds) {
          let timelineSegment = this.visibleTimelineDataSet.getSegment(timelineSegmentId);
          if (timelineSegment.begin === null) continue;
          if (smallestBegin.isGreaterThan(timelineSegment.begin)) {
            smallestBegin = timelineSegment.begin;
          }
        }
        return smallestBegin;
      }

      function getLargestEndInSelectedTimelineSegments() {
        let largestEnd = this.timelineViewBeginMin;
        for (let timelineSegmentId of this.selectedTimelineSegmentIds) {
          let timelineSegment = this.visibleTimelineDataSet.getSegment(timelineSegmentId);
          if (timelineSegment.end === null) continue;
          if (largestEnd.isLessThan(timelineSegment.end)) {
            largestEnd = timelineSegment.end;
          }
        }
        return largestEnd;
      }

      function clampTimeOffsetOnLeftEdgeViaSmallestDuration(offsetTime, smallestDuration) {
        let offsetTimeMax = smallestDuration.subtract(this.minimumSegmentDuration);
        return offsetTime.ceilTo(offsetTimeMax);
      }

      function clampTimeOffsetOnRightEdgeViaSmallestDuration(offsetTime, smallestDuration) {
        let offsetTimeMin = this.minimumSegmentDuration.subtract(smallestDuration);
        return offsetTime.floorTo(offsetTimeMin);
      }

      function clampTimeOffsetViaSmallestBegin(offsetTime, smallestBegin) {
        let begin = smallestBegin.add(offsetTime);
        let beginMin = this.timelineViewBeginMin;
        if (begin.isLessThan(beginMin)) {
          offsetTime = beginMin.subtract(smallestBegin);
        }
        return offsetTime;
      }

      function clampTimeOffsetViaLargestEnd(offsetTime, largestEnd) {
        let end = largestEnd.add(offsetTime);
        let endMax = this.timelineViewEndMax;
        if (end.isGreaterThan(endMax)) {
          offsetTime = endMax.subtract(largestEnd);
        }
        return offsetTime;
      }

      function areAllSelectedTimelineSegmentsDurationInfinity() {
        for (let timelineSegmentId of this.selectedTimelineSegmentIds) {
          let timelineSegment = this.visibleTimelineDataSet.getSegment(timelineSegmentId);
          if (timelineSegment.begin !== null) return false;
          if (timelineSegment.end !== null) return false;
        }
        return true;
      }
    },

    $_updateMouseEventContext(event) {
      const stepValueScale = 0.5;
      const autoScrollMinimumInterval = 100;
      {
        let [ timelineCanvasLocalX, timelineCanvasLocalY ] = this.$_eventToTimelineCanvasLocalXY(event);
        let timelineCanvasClampedLocalX = this.$_clampTimelineCanvasLocalX(timelineCanvasLocalX);
        let timelineCanvasClampedLocalY = this.$_clampTimelineCanvasLocalY(timelineCanvasLocalY);
        let timelinePosition = this.$_timelineCanvasLocalYToTimelinePosition(timelineCanvasClampedLocalY);
        let time = this.$_timelineCanvasLocalXToTime(timelineCanvasClampedLocalX);
        let snappedTimelineCanvasLocalX = this.$_getSnappedTimelineCanvasLocalX(timelineCanvasClampedLocalX);
        let snappedTime = this.$_timelineCanvasLocalXToTime(snappedTimelineCanvasLocalX);
        let timeAndTimelinePositionAtMousemove = new TimeAndTimelinePosition(time, snappedTime, timelinePosition);
        if (this.$data.$_isMousedownOnScrollBar) {
          let mousemoveOffsetPx = timelineCanvasLocalX - this.$data.$_timelineCanvasLocalXAtMousedownOnScrollBar;
          let nextTimelineViewBegin = this.$data.$_timelineViewBeginAtMousedownOnScrollBar.add(this.$_scrollBarPxToScaledTime(mousemoveOffsetPx));
          this.$_setTimelineViewBegin(nextTimelineViewBegin);
        } else if (this.$data.$_timeAndTimelinePositionAtMousedown !== undefined) {
          let timelineCanvasLocalCoordsAtMousemove = new TimelineCanvasLocalCoords(timelineCanvasClampedLocalX, timelineCanvasClampedLocalY);
          let edgeInfoAtMousemove = new EdgeInfo(timelineCanvasLocalCoordsAtMousemove, this.$_timelineCanvasWidthPx, this.$_timelineCanvasContainerHeightPx);
          updateScrollPending.call(this, edgeInfoAtMousemove, timelineCanvasLocalCoordsAtMousemove);
          if (!this.$data.$_isAutoScrollPending) {
            autoScrollX.call(this, edgeInfoAtMousemove);
            autoScrollY.call(this, edgeInfoAtMousemove);
          }
          if (!this.$data.$_timeAndTimelinePositionAtMousedown.isEqualTo(timeAndTimelinePositionAtMousemove)) {
            this.$data.$_isDragging = true;
          }
          if (this.$_timelineSegmentDomRectsToDragWithInfo !== undefined) {
            let edgeType = this.$_timelineSegmentDomRectsToDragWithInfo.edgeType;
            let dragOffsetTime = snappedTime.getOffsetFrom(this.$data.$_timeAndTimelinePositionAtMousedown.time);
            this.$_setSegmentDragOffsetTime(dragOffsetTime, edgeType);
          }
        }
        this.$data.$_timelineCanvasLocalCoordsAtMousemove.x = timelineCanvasLocalX;
        this.$data.$_timelineCanvasLocalCoordsAtMousemove.y = timelineCanvasLocalY;
        this.$data.$_timeAndTimelinePositionAtMousemove = timeAndTimelinePositionAtMousemove;
      }

      function updateScrollPending(edgeInfoAtMousemove, timelineCanvasLocalCoordsAtMousemove) {
        if (this.$data.$_isAutoScrollPending) {
          if (edgeInfoAtMousemove.isOnTopEdge) {
            if (this.$data.$_edgeInfoAtMousedown.isOnTopEdge) {
              if (timelineCanvasLocalCoordsAtMousemove.y < this.$_timelineCanvasLocalYAtMousedown) {
                this.$data.$_isAutoScrollPending = false;
              }
            } else {
              this.$data.$_isAutoScrollPending = false;
            }
          } else if (edgeInfoAtMousemove.isOnBottomEdge) {
            if (this.$data.$_edgeInfoAtMousedown.isOnBottomEdge) {
              if (timelineCanvasLocalCoordsAtMousemove.y > this.$_timelineCanvasLocalYAtMousedown) {
                this.$data.$_isAutoScrollPending = false;
              }
            } else {
              this.$data.$_isAutoScrollPending = false;
            }
          }
          if (edgeInfoAtMousemove.isOnRightEdge) {
            if (this.$data.$_edgeInfoAtMousedown.isOnRightEdge) {
              if (timelineCanvasLocalCoordsAtMousemove.x > this.$_timelineCanvasLocalXAtMousedown) {
                this.$data.$_isAutoScrollPending = false;
              }
            } else {
              this.$data.$_isAutoScrollPending = false;
            }
          } else if (edgeInfoAtMousemove.isOnLeftEdge) {
            if (this.$data.$_edgeInfoAtMousedown.isOnLeftEdge) {
              if (timelineCanvasLocalCoordsAtMousemove.x < this.$_timelineCanvasLocalXAtMousedown) {
                this.$data.$_isAutoScrollPending = false;
              }
            } else {
              this.$data.$_isAutoScrollPending = false;
            }
          }
        }
      }

      function autoScrollX(edgeInfoAtMousemove) {
        if (this.$data.$_autoScrollXInterval === undefined) {
          if (edgeInfoAtMousemove.isOnRightEdge || edgeInfoAtMousemove.isOnLeftEdge) {
            this.$data.$_autoScrollXInterval = window.setInterval(
              () => {
                this.$_stepTimeOffset((edgeInfoAtMousemove.isOnRightEdge)? stepValueScale : -stepValueScale);
              },
              autoScrollMinimumInterval
            );
          }
        } else {
          if (!edgeInfoAtMousemove.isOnRightEdge && !edgeInfoAtMousemove.isOnLeftEdge) {
            window.clearInterval(this.$data.$_autoScrollXInterval);
            this.$data.$_autoScrollXInterval = undefined;
          }
        }
      }

      function autoScrollY(edgeInfoAtMousemove) {
        if (this.$data.$_autoScrollYInterval === undefined) {
          if (edgeInfoAtMousemove.isOnTopEdge || edgeInfoAtMousemove.isOnBottomEdge) {
            this.$data.$_autoScrollYInterval = window.setInterval(
              () => {
                this.$_stepVerticalOffset((edgeInfoAtMousemove.isOnBottomEdge)? -stepValueScale : stepValueScale);
              },
              autoScrollMinimumInterval
            );
          }
        } else {
          if (!edgeInfoAtMousemove.isOnTopEdge && !edgeInfoAtMousemove.isOnBottomEdge) {
            window.clearInterval(this.$data.$_autoScrollYInterval);
            this.$data.$_autoScrollYInterval = undefined;
          }
        }
      }
    },

    $_getSnappedTimelineCanvasLocalX(timelineCanvasLocalX) {
      {
        if (!this.isSnapEnabled) return timelineCanvasLocalX;
        let snapOffsetMinimum = undefined;
        if (this.$_isPlayTimeInView) {
          let timelineCanvasLocalXPlayTime = this.$_scaledTimeToPx(this.playTime.getOffsetFrom(this.$data.$_timelineViewBegin));
          let snapOffsetToPlayTime = getSnapOffset.call(this, timelineCanvasLocalXPlayTime, timelineCanvasLocalX);
          snapOffsetMinimum = getUpdatedSnapOffsetMinimum(snapOffsetMinimum, snapOffsetToPlayTime);
        }
        if (this.$_isMarkerSet) {
          if (this.timelineMarker.begin !== null) {
            let timelineCanvasLocalXMarkerBegin = this.$_scaledTimeToPx(this.timelineMarker.begin.getOffsetFrom(this.$data.$_timelineViewBegin));
            let snapOffsetToMarkerBegin = getSnapOffset.call(this, timelineCanvasLocalXMarkerBegin, timelineCanvasLocalX);
            snapOffsetMinimum = getUpdatedSnapOffsetMinimum(snapOffsetMinimum, snapOffsetToMarkerBegin);
          }
          if (this.timelineMarker.end !== null) {
            let timelineCanvasLocalXMarkerEnd = this.$_scaledTimeToPx(this.timelineMarker.end.getOffsetFrom(this.$data.$_timelineViewBegin));
            let snapOffsetToMarkerEnd = getSnapOffset.call(this, timelineCanvasLocalXMarkerEnd, timelineCanvasLocalX);
            snapOffsetMinimum = getUpdatedSnapOffsetMinimum(snapOffsetMinimum, snapOffsetToMarkerEnd);
          }
        }
        for (let segmentDomRects of Object.values(this.$_timelineSegmentDomRects)) {
          for (let timelineSegmentDomRect of Object.values(segmentDomRects)) {
            let timelineSegmentBeginLocalX = timelineSegmentDomRect.x;
            if (timelineSegmentBeginLocalX >= 0) {
              let snapOffsetToTimelineSegmentBegin = getSnapOffset.call(this, timelineSegmentBeginLocalX, timelineCanvasLocalX);
              snapOffsetMinimum = getUpdatedSnapOffsetMinimum(snapOffsetMinimum, snapOffsetToTimelineSegmentBegin);
            }
            let timelineSegmentEndLocalX = timelineSegmentDomRect.x + timelineSegmentDomRect.width;
            if (timelineSegmentEndLocalX <= this.$_timelineCanvasWidthPx) {
              let snapOffsetToTimelineSegmentEnd = getSnapOffset.call(this, timelineSegmentEndLocalX, timelineCanvasLocalX);
              snapOffsetMinimum = getUpdatedSnapOffsetMinimum(snapOffsetMinimum, snapOffsetToTimelineSegmentEnd);
            }
          }
        }
        return timelineCanvasLocalX + ((snapOffsetMinimum === undefined)? 0 : snapOffsetMinimum);
      }

      function getUpdatedSnapOffsetMinimum(currentSnapOffsetMinimum, snapOffset) {
        if (currentSnapOffsetMinimum === undefined) {
          return snapOffset;
        } else {
          if (snapOffset === undefined) {
            return currentSnapOffsetMinimum;
          } else {
            let currentSnapOffsetMinimumAmount = Math.abs(currentSnapOffsetMinimum);
            let snapOffsetAmount = Math.abs(snapOffset);
            return (snapOffsetAmount < currentSnapOffsetMinimumAmount)? snapOffset : currentSnapOffsetMinimum;
          }
        }
      }

      function getSnapOffset(snapTargetTimelineCanvasLocalX, timelineCanvasLocalX) {
        let snapBaseTimelineCanvasLocalX = undefined;
        let offsetPxBySnapBase = undefined;
        if (this.$data.$_timelineSegmentIdWithInfoAtMousedown && this.$_isDraggingSegments) {
          if (this.$data.$_timelineSegmentIdWithInfoAtMousedown.isOnRightEdge) {
            offsetPxBySnapBase = this.$data.$_timelineSegmentIdWithInfoAtMousedown.offsetPxByRightEdge;
            snapBaseTimelineCanvasLocalX = timelineCanvasLocalX - offsetPxBySnapBase;
          } else if (this.$data.$_timelineSegmentIdWithInfoAtMousedown.isOnLeftEdge) {
            offsetPxBySnapBase = this.$data.$_timelineSegmentIdWithInfoAtMousedown.offsetPxByLeftEdge;
            snapBaseTimelineCanvasLocalX = timelineCanvasLocalX - offsetPxBySnapBase;
          } else {
            let offsetPxByLeftEdge = this.$data.$_timelineSegmentIdWithInfoAtMousedown.offsetPxByLeftEdge;
            let snapBaseCandidateTimelineCanvasLocalXLeftEdge = timelineCanvasLocalX - offsetPxByLeftEdge;
            let offsetPxByRightEdge = this.$data.$_timelineSegmentIdWithInfoAtMousedown.offsetPxByRightEdge;
            let snapBaseCandidateTimelineCanvasLocalXRightEdge = timelineCanvasLocalX - offsetPxByRightEdge;
            let distanceBetweenSnapBaseCandidateLeftEdgeAndSnapTarget = Math.abs(snapTargetTimelineCanvasLocalX - snapBaseCandidateTimelineCanvasLocalXLeftEdge);
            let distanceBetweenSnapBaseCandidateRightEdgeAndSnapTarget = Math.abs(snapTargetTimelineCanvasLocalX - snapBaseCandidateTimelineCanvasLocalXRightEdge);
            if (distanceBetweenSnapBaseCandidateLeftEdgeAndSnapTarget < distanceBetweenSnapBaseCandidateRightEdgeAndSnapTarget) {
              offsetPxBySnapBase = offsetPxByLeftEdge;
              snapBaseTimelineCanvasLocalX = snapBaseCandidateTimelineCanvasLocalXLeftEdge;
            } else {
              offsetPxBySnapBase = offsetPxByRightEdge;
              snapBaseTimelineCanvasLocalX = snapBaseCandidateTimelineCanvasLocalXRightEdge;
            }
          }
        } else {
          snapBaseTimelineCanvasLocalX = timelineCanvasLocalX;
          offsetPxBySnapBase = 0;
        }
        let distanceBetweenSnapBaseAndSnapTarget = Math.abs(snapTargetTimelineCanvasLocalX - snapBaseTimelineCanvasLocalX);
        if (distanceBetweenSnapBaseAndSnapTarget < snapWidthPx) {
          return snapTargetTimelineCanvasLocalX + offsetPxBySnapBase - timelineCanvasLocalX;
        } else {
          return undefined;
        }
      }
    },

    $_isTimeInMarker(time) {
      if (!this.$_isMarkerSet) return false;
      return this.timelineMarker.isInRange(time);
    },

    $_resetOnMouseEvent() {
      this.$data.$_timeAndTimelinePositionAtMousedown = undefined;
      this.$data.$_timelineSegmentIdWithInfoAtMousedown = undefined;
      this.$data.$_edgeInfoAtMousedown = undefined;
      this.$data.$_firstMouseButtonAtMousedown = undefined;
      this.$data.$_timelineCanvasLocalXAtMousedownOnScrollBar = undefined;
      this.$data.$_timelineViewBeginAtMousedownOnScrollBar = undefined;
      this.$data.$_isMousedownOnScrollBar = false;
      this.$data.$_isMousedownOnRulerArea = false;
      this.$data.$_isDragging = false;
      this.$data.$_isAutoScrollPending = false;
      if (this.$data.$_autoScrollXInterval) {
        window.clearInterval(this.$data.$_autoScrollXInterval);
        this.$data.$_autoScrollXInterval = undefined;
      }
      if (this.$data.$_autoScrollYInterval) {
        window.clearInterval(this.$data.$_autoScrollYInterval);
        this.$data.$_autoScrollYInterval = undefined;
      }
      this.$data.$_segmentDragOffsetTime = TimeValue.zero;
    },

    $_setViewMode(currentViewMode) {
      if (this.$data.$_currentViewMode === currentViewMode) return;
      if (this.$data.$_currentViewMode === viewMode.position) {
        this.clearMarker();
        this.$_emitUpdateIsLoopEnabled(false);
      }
      this.$data.$_currentViewMode = currentViewMode;
    },

    $_isTimelineSegmentVisible(timelineSegmentId) {
      let timelineDataId = timelineSegmentId.timelineDataId;
      if (Object.keys(this.visibleTimelineDataSet).includes(timelineDataId)) {
        let visibleTimelineData = this.visibleTimelineDataSet[timelineSegmentId.timelineDataId];
        let segmentId = timelineSegmentId.segmentId;
        if (Object.keys(visibleTimelineData.segments).includes(segmentId)) {
          return true;
        }
      }
      return false;
    },

    $_findFirstVisibleTimelineSegmentId() {
      for (let [ timelineDataId, sortedVisibleSegmentIdxToIdMap ] of this.sortedVisibleSegmentIdxToIdMaps) {
        let numSegments = sortedVisibleSegmentIdxToIdMap.length;
        for (let sortedSegmentIdx = 0; sortedSegmentIdx < numSegments; ++sortedSegmentIdx) {
          let segmentId = sortedVisibleSegmentIdxToIdMap[sortedSegmentIdx];
          return new TimelineSegmentId(timelineDataId, segmentId);
        }
      }
      return undefined;
    },

    $_forceTimelineSegmentDomRectBeInTimelineView(timelineSegmentId) {
      let offsetRect = this.$refs.timelineSegmentCanvas.getOffsetForRectTimelineSegmentToBeInCanvas(timelineSegmentId);
      if (offsetRect !== undefined) {
        this.$_setTimelineViewBegin(this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(offsetRect.x)));
        this.$_setVerticalOffsetPx(this.$data.$_verticalOffsetPx + offsetRect.y);
      }
    },
    
    $_updateNearestTimelineSegmentBaseTime(timelineSegmentId) {
      {
        let timelineDataId = timelineSegmentId.timelineDataId;
        let segmentId = timelineSegmentId.segmentId;
        let segment = this.visibleTimelineDataSet[timelineDataId].segments[segmentId];
        if (segment === undefined) {
          logger.warn(this.visibleTimelineDataSet[timelineDataId], timelineDataId, segmentId);
        }
        this.$data.$_timelineSegmentNearestBaseTime.assign(getSegmentCenter.call(this, segment));
      }

      function getSegmentCenter(segment) {
        let begin = (segment.begin === null)? this.timelineViewBeginMin : segment.begin;
        let end = (segment.end === null)? this.timelineViewEndMax : segment.end;
        return begin.add(end).half;
      }
    },

    $_visuallyOffsetTimelineSegmentId(targetTimelineSegmentId, offsetAmount) {
      let lastSelectedTimelineDataId = targetTimelineSegmentId.timelineDataId;
      let lastSelectedSegmentId = targetTimelineSegmentId.segmentId;
      let visibleSegmentIdToSortedIdxMap = this.visibleSegmentIdToSortedIdxMaps.get(lastSelectedTimelineDataId);
      let numSegments = visibleSegmentIdToSortedIdxMap.size;
      let lastSelectedSegmentIdxInSortedMap = visibleSegmentIdToSortedIdxMap.get(lastSelectedSegmentId);
      let offsetSegmentIdx = utils.clamp(lastSelectedSegmentIdxInSortedMap + offsetAmount, 0, numSegments - 1);
      let offsetSegmentId = this.sortedVisibleSegmentIdxToIdMaps.get(lastSelectedTimelineDataId)[offsetSegmentIdx];
      this.$_selectTimelineSegmentCore(new TimelineSegmentId(lastSelectedTimelineDataId, offsetSegmentId));
    },

    $_selectTimelineSegmentCore(
      timelineSegmentId,
      {
        retainsViewMode = false,
        retainsSelection = false,
        updatesNearestTimelineSegmentBase = true,
        forcesToBeInTimelineView = true,
      } = {}
    ) {
      this.$_selectTimelineSegmentsCore(
        [ timelineSegmentId ],
        {
          retainsViewMode,
          retainsSelection,
          updatesNearestTimelineSegmentBase,
          forcesToBeInTimelineView,
        },
      );
    },

    $_selectTimelineSegmentsCore(
      timelineSegmentIds,
      {
        retainsViewMode = false,
        retainsSelection = false,
        updatesNearestTimelineSegmentBase = true,
        forcesToBeInTimelineView = true,
      } = {}
    ) {
      if (!retainsViewMode) {
        if (this.$data.$_currentViewMode !== viewMode.position) {
          this.$_setViewMode(viewMode.select);
        }
      }
      if (!retainsSelection) {
        this.clearSelectedTimelineSegments();
      }
      this.selectTimelineSegments(...timelineSegmentIds);
      if (updatesNearestTimelineSegmentBase || forcesToBeInTimelineView) {
        let firstSelectedTimelineSegmentId = this.$_findLastTimelineSegmentId(timelineSegmentIds);

        if (forcesToBeInTimelineView) {
          this.$_forceTimelineSegmentDomRectBeInTimelineView(firstSelectedTimelineSegmentId);
        }

        if (updatesNearestTimelineSegmentBase) {
          this.$_updateNearestTimelineSegmentBaseTime(firstSelectedTimelineSegmentId);
        }
      }
    },

    $_isTimelineSegmentIdSelected(timelineSegmentId) {
      for (let selectedTimelineSegmentId of this.selectedTimelineSegmentIds) {
        if (selectedTimelineSegmentId.isSameAs(timelineSegmentId)) {
          return true;
        }
      }
      return false;
    },

    $_findFirstTimelineSegmentId(targetTimelineSegmentIds) {
      for (let timelineDataId of this.visibleTimelineDataIdxToId) {
        for (let segmentId of this.sortedVisibleSegmentIdxToIdMaps.get(timelineDataId)) {
          for (let targetTimelineSegmentId of targetTimelineSegmentIds) {
            if (timelineDataId === targetTimelineSegmentId.timelineDataId) {
              if (segmentId === targetTimelineSegmentId.segmentId) {
                return targetTimelineSegmentId;
              }
            }
          }
        }
      }
      return undefined;
    },

    $_findLastTimelineSegmentId(targetTimelineSegmentIds) {
      for (let timelineDataId of this.visibleTimelineDataIdxToId) {
        let reversedSortedVisibleSegmentIdxToId = this.$_reversedSortedVisibleSegmentIdxToIdMaps.get(timelineDataId);
        for (let segmentId of reversedSortedVisibleSegmentIdxToId) {
          for (let targetTimelineSegmentId of targetTimelineSegmentIds) {
            if (timelineDataId === targetTimelineSegmentId.timelineDataId) {
              if (segmentId === targetTimelineSegmentId.segmentId) {
                return targetTimelineSegmentId;
              }
            }
          }
        }
      }
      return undefined;
    },

    $_scrollBarPxToScaledTime(px) {
      return TimeValue.msec(resolve(px, this.$_timeScrollBarTimeResolution));
    },

    $_scaledTimeToScrollBarPx(time) {
      return unitize(time.msec, this.$_timeScrollBarTimeResolution);
    },

    $_pxToScaledTime(px) {
      return TimeValue.msec(resolve(px, this.$data.$_timeResolution));
    },

    $_scaledTimeToPx(time) {
      return unitize(time.msec, this.$data.$_timeResolution);
    },

    $_pxToTimelinePosition(px) {
      return resolve(px, this.$data.$_timelinePositionResolution);
    },

    $_timelinePositionToPx(timelinePosition) {
      return unitize(timelinePosition, this.$data.$_timelinePositionResolution);
    },

    $_timelineCanvasLocalXToTime(timelineCanvasLocalX) {
      return this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(timelineCanvasLocalX)).round();
    },

    $_timeToTimelineCanvasLocalX(time) {
      return this.$_scaledTimeToPx(time.getOffsetFrom(this.$data.$_timelineViewBegin));
    },

    $_timelineCanvasLocalYToTimelinePosition(timelineCanvasLocalY) {
      return this.$_pxToTimelinePosition(timelineCanvasLocalY - this.$data.$_verticalOffsetPx);
    },

    $_timelinePositionToTimelineCanvasLocalY(timelinePosition) {
      return this.$_timelinePositionToPx(timelinePosition) + this.$data.$_verticalOffsetPx;
    },
    
    $_timelineCanvasLocalYToVisibleTimelineDataIdx(timelineCanvasLocalY) {
      let verticalOffsetPx = timelineCanvasLocalY - this.$data.$_verticalOffsetPx;
      let visibleTimelineDataIdx = Math.floor(verticalOffsetPx / this.$_timelineHeightPx);
      if ((visibleTimelineDataIdx < 0) || (visibleTimelineDataIdx >= this.$_numVisibleTimelines)) return undefined;
      return visibleTimelineDataIdx;
    },

    $_stepPageTimeOffset(inverted) {
      let timeStep = this.$_timelineCanvasWidthPx * ((inverted)? -1 : 1);
      this.$_setTimelineViewBegin(this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(timeStep)));
    },

    $_stepTimeOffset(scale) {
      let timeStep = timeStepPxOnScroll * scale;
      this.$_setTimelineViewBegin(this.$data.$_timelineViewBegin.add(this.$_pxToScaledTime(timeStep)));
    },

    $_stepVerticalOffset(scale) {
      let verticalStepPx = verticalStepPxOnScroll * scale;
      let steppedVerticalOffsetPx = this.$data.$_verticalOffsetPx + verticalStepPx;
      this.$_setVerticalOffsetPx(steppedVerticalOffsetPx);
    },

    $_setTimelineViewEnd(newTimelineViewEnd) {
      this.$_setTimelineViewBegin(newTimelineViewEnd.subtract(this.$_timelineViewDuration));
    },

    $_setTimelineViewCenter(newTimelineViewCenter) {
      this.$_setTimelineViewBegin(newTimelineViewCenter.subtract(this.$_timelineViewDuration.half));
    },

    $_setTimelineViewBegin(newTimelineViewBegin) {
      newTimelineViewBegin = this.$_clampTimelineViewBegin(newTimelineViewBegin);
      let timelineViewBeginOffsetTime = newTimelineViewBegin.getOffsetFrom(this.$data.$_timelineViewBegin);
      this.$data.$_timeAndTimelinePositionAtMousemove.time.addSelf(timelineViewBeginOffsetTime);
      this.$data.$_timeAndTimelinePositionAtMousemove.snappedTime.addSelf(timelineViewBeginOffsetTime);
      this.$data.$_timelineViewBegin.assign(newTimelineViewBegin);
    },

    $_setVerticalOffsetPx(newVerticalOffsetPx) {
      newVerticalOffsetPx = this.$_clampVerticalOffsetPx(Math.round(newVerticalOffsetPx));
      let timelinePosition = this.$_pxToTimelinePosition(newVerticalOffsetPx - this.$data.$_verticalOffsetPx);
      this.$data.$_timeAndTimelinePositionAtMousemove.timelinePosition -= timelinePosition;
      this.$data.$_verticalOffsetPx = newVerticalOffsetPx;
    },

    $_setWaveformScale(nextWaveformScale) {
      this.$data.$_waveformScale = utils.clamp(nextWaveformScale, waveformScaleMin, waveformScaleMax);
    },

    $_initializeView() {
      this.$_updateViewSize();
      this.$data.$_timeResolution = this.$data.$_timeResolutionMin;
      this.$data.$_timelineViewBegin.assign(this.$_timelineViewBeginMinIncludingMargin);
    },

    $_updateViewSize() {
      if (this.$el.style.display === 'none') return;
      this.$data.$_timelineCanvasContainerBoundingClientRect = this.$refs.timelineCanvasContainer.getBoundingClientRect();
      this.$data.$_timelineScrollBarWidthPx = this.$refs.timeScrollBarCanvas.$el.getBoundingClientRect().height;
      this.$data.$_timelineListContainerWidthPx = this.$el.clientWidth;
      let timelineViewPreBeginMargin = this.$_timelineViewDurationMax.multiply(timelineViewPreBeginMarginPxMax / (timelineViewPreBeginMarginPxMax - this.$_timelineCanvasWidthPx));
      let timeResolutionMin = this.$_timelineCanvasWidthPx / this.$_timelineViewDurationMax.subtract(timelineViewPreBeginMargin).msec;
      let currentTimeResolution = this.$data.$_timeResolution;
      let newTimeResolution = (currentTimeResolution < timeResolutionMin)? timeResolutionMin : currentTimeResolution;
      this.$data.$_timeResolutionMin = timeResolutionMin;
      this.$data.$_timeResolution = newTimeResolution;
      this.$_setTimelineViewBegin(this.$data.$_timelineViewBegin);
    },

    $_selectAllVisibleSegments(timelineDataIdx) {
      let visibleTimelineDataId = this.visibleTimelineDataIdxToId[timelineDataIdx];
      let visibleTimelineData = this.visibleTimelineDataSet[visibleTimelineDataId];
      let visibleSegmentIds = Object.keys(visibleTimelineData.segments);
      let visibleTimelineSegmentIds = visibleSegmentIds.map(visibleSegmentId => new TimelineSegmentId(visibleTimelineDataId, visibleSegmentId));
      let lastVisibleTimelineSegmentId = visibleTimelineSegmentIds[visibleTimelineSegmentIds.length - 1];
      if (lastVisibleTimelineSegmentId) {
        this.$_selectTimelineSegmentsCore(visibleTimelineSegmentIds);
      }
    },

    $_clampTimelineViewBegin(timelineViewBegin) {
      let timelineViewEnd = timelineViewBegin.add(this.$_timelineViewDuration);
      if (timelineViewEnd.isGreaterThan(this.timelineViewEndMax)) {
        let overrunDuration = timelineViewEnd.getOffsetFrom(this.timelineViewEndMax);
        timelineViewBegin = timelineViewBegin.subtract(overrunDuration);
      }
      if (timelineViewBegin.isLessThan(this.$_timelineViewBeginMinIncludingMargin)) {
        timelineViewBegin = this.$_timelineViewBeginMinIncludingMargin;
      }
      return timelineViewBegin;
    },

    $_clampVerticalOffsetPx(verticalOffsetPx) {
      return utils.clamp(verticalOffsetPx, this.$_verticalOffsetPxMin, rulerVerticalOffsetPx);
    },

    $_clampTimelinePositionResolution(timelinePositionResolution) {
      return utils.clamp(timelinePositionResolution, timelinePositionResolutionMin, timelinePositionResolutionMax);
    },

    $_clampTimeResolution(timeResolution) {
      return utils.clamp(timeResolution, this.$data.$_timeResolutionMin, timeResolutionMax);
    },

    $_clampTimelineCanvasLocalX(timelineCanvasLocalX) {
      let timelineCanvasLocalXMin = this.$_timeToTimelineCanvasLocalX(this.timelineViewBeginMin);
      let timelineCanvasLocalXMax = this.$_timeToTimelineCanvasLocalX(this.timelineViewEndMax);
      timelineCanvasLocalX = utils.clamp(timelineCanvasLocalX, timelineCanvasLocalXMin, timelineCanvasLocalXMax);
      return utils.clamp(timelineCanvasLocalX, 0, this.$_timelineCanvasWidthPx);
    },

    $_clampTimelineCanvasLocalY(timelineCanvasLocalY) {
      return utils.clamp(timelineCanvasLocalY, rulerVerticalOffsetPx, this.$_timelineCanvasHeightPx);
    },

    $_updateTimelineViewBeginAndTimeResolution(fixedTimelineCanvasLocalX, nextTimeResolution) {
      {
        let currentTimelineViewBegin = this.$data.$_timelineViewBegin;
        let currentTimeResolution = this.$data.$_timeResolution;
        nextTimeResolution = this.$_clampTimeResolution(nextTimeResolution);
        let currentFixedTimelineViewOffset = TimeValue.msec(resolve(fixedTimelineCanvasLocalX, currentTimeResolution));
        if (currentTimelineViewBegin.add(currentFixedTimelineViewOffset).isLessThan(this.timelineViewBeginMin)) {
          currentFixedTimelineViewOffset = this.timelineViewBeginMin.getOffsetFrom(currentTimelineViewBegin);
          fixedTimelineCanvasLocalX = unitize(currentFixedTimelineViewOffset.msec, currentTimeResolution);
        }
        let nextFixedTimelineViewOffset = TimeValue.msec(resolve(fixedTimelineCanvasLocalX, nextTimeResolution));
        /*************************************************
         * Ex) Current-scaled Duration[msec]: 12
         *     Double-scaled Duration[msec]:  6
         *
         *     Begin     Fixed
         *     |=====12====|-------
         *     ------|==6==|-------
         * 
         *     |==x==| x(compensating) = 12(current) - 6(doubled)
         *************************************************/
        let timelineViewBeginCompensatingOffset = currentFixedTimelineViewOffset.subtract(nextFixedTimelineViewOffset);
        this.$data.$_timeResolution = nextTimeResolution;
        let nextTimelineViewBegin = this.$_clampTimelineViewBegin(currentTimelineViewBegin.add(timelineViewBeginCompensatingOffset));
        this.$data.$_timeAndTimelinePositionAtMousemove.time.assign(
          getFixedTimeAtNextTimeResolution(
            this.$data.$_timeAndTimelinePositionAtMousemove.time,
            currentTimelineViewBegin,
            nextTimelineViewBegin,
            currentTimeResolution,
            nextTimeResolution,
          )
        );
        this.$data.$_timeAndTimelinePositionAtMousemove.snappedTime.assign(
          getFixedTimeAtNextTimeResolution(
            this.$data.$_timeAndTimelinePositionAtMousemove.snappedTime,
            currentTimelineViewBegin,
            nextTimelineViewBegin,
            currentTimeResolution,
            nextTimeResolution,
          )
        );
        this.$data.$_timelineViewBegin = nextTimelineViewBegin;
      }

      function getFixedTimeAtNextTimeResolution(fixedTime, currentTimelineViewBegin, nextTimelineViewBegin, currentTimeResolution, nextTimeResolution) {
        let fixedTimelineViewOffset = fixedTime.getOffsetFrom(currentTimelineViewBegin);
        let fixedTimelineViewOffsetPx = unitize(fixedTimelineViewOffset.msec, currentTimeResolution);
        let fixedTimelineViewOffsetAtNextTimeResolution = TimeValue.msec(resolve(fixedTimelineViewOffsetPx, nextTimeResolution));
        return nextTimelineViewBegin.add(fixedTimelineViewOffsetAtNextTimeResolution);
      }
    },

    $_updateVerticalOffsetPxAndTimelinePositionResolution(fixedTimelineCanvasLocalY, nextTimelinePositionResolution) {
      let currentTimelinePositionResolution = this.$data.$_timelinePositionResolution;
      nextTimelinePositionResolution = this.$_clampTimelinePositionResolution(nextTimelinePositionResolution);
      let nextVerticalRatio = nextTimelinePositionResolution / currentTimelinePositionResolution;
      let currentFixedVerticalOffsetPx = fixedTimelineCanvasLocalY - this.$data.$_verticalOffsetPx;
      let nextFixedVerticalOffsetPx = currentFixedVerticalOffsetPx * nextVerticalRatio;
      /*************************************************
       * Ex) Current-scaled Offset[px]: 10
       *     Double-scaled Offset[px]:  5
       *
       *     VerticalOffset
       *     |             Origin
       *     |             |         Current Timeline View Vertical Offset
       *     |======14=====|====10===|
       *     ------------|=====12====|
       * 
       *     ------------|x| x(compensating) = 10 - 12
       *************************************************/
      this.$data.$_timelinePositionResolution = nextTimelinePositionResolution;
      this.$data.$_verticalOffsetPx = this.$_clampVerticalOffsetPx(Math.round(fixedTimelineCanvasLocalY - nextFixedVerticalOffsetPx));
      let currentVerticalOffsetPx = unitize(this.$data.$_timeAndTimelinePositionAtMousemove.timelinePosition, currentTimelinePositionResolution);
      this.$data.$_timeAndTimelinePositionAtMousemove.timelinePosition = resolve(currentVerticalOffsetPx, nextTimelinePositionResolution);
    },

    $_toggleSetOrUnsetRealtimeSegmentCreationTarget(timelineDataId) {
      let existingTimelineDataIdIdx = this.$data.$_realtimeSegmentCreationTargetTimelineDataIds.indexOf(timelineDataId);
      if (existingTimelineDataIdIdx === -1) {
        let timelineData = this.visibleTimelineDataSet[timelineDataId];
        let immutableReason = this.getTimelineDataImmutableReason(timelineData, false);
        if (immutableReason !== undefined) {
          this.registerFooterMessage(immutableReason);
        } else {
          this.$data.$_realtimeSegmentCreationTargetTimelineDataIds.push(timelineDataId);
        }
      } else {
        this.$data.$_realtimeSegmentCreationTargetTimelineDataIds.splice(existingTimelineDataIdIdx, 1);
      }
    },

    $_toggleFollowPlayBarFlag() {
      this.$data.$_followPlayBarFlag = !this.$data.$_followPlayBarFlag;
    },

    $_recordRealtimeSegmentBegin() {
      this.setMarker(this.playTime, this.playTime);
      this.$data.$_isRealtimeSegmentOpen = true;
    },

    $_recordRealtimeSegmentEnd() {
      if (!this.$data.$_isRealtimeSegmentOpen) return;
      if (this.$_isAnyTimelineRealtimeSegmentCreationTarget) {
        if (this.timelineMarker.duration.msec < this.minimumSegmentDuration.msec) {
          this.registerFooterMessage('Segment is too short.');
        } else {
          this.atomicChanges(
            'setting segment',
            'Segment set.',
            () => {
              for (let timelineDataId of this.$data.$_realtimeSegmentCreationTargetTimelineDataIds) {
                let timelineData = this.visibleTimelineDataSet[timelineDataId];
                let newSegment = timelineData.segmentDataType.generateEmpty(
                  this.timelineMarker.begin.clone(),
                  this.timelineMarker.end.clone(),
                );
                this.setNewSegment(
                  timelineDataId,
                  timelineData.segmentDataType,
                  newSegment,
                );
              }
            },
          );
        }
      }
      this.$data.$_isRealtimeSegmentOpen = false;
    },
    
    $_initializePositionEditTargetTimelineSegment(timelineSegmentId) {
      let lastSelectedTimelineSegment = this.visibleTimelineDataSet.getSegment(timelineSegmentId);
      this.$data.$_positionEditTargetTimelineSegmentId = timelineSegmentId;
      if (lastSelectedTimelineSegment.begin === null) {
        this.$data.$_positionEditTargetTimelineSegmentBegin = null;
      } else {
        this.$data.$_positionEditTargetTimelineSegmentBegin = lastSelectedTimelineSegment.begin.clone();
      }
      if (lastSelectedTimelineSegment.end === null) {
        this.$data.$_positionEditTargetTimelineSegmentEnd = null;
      } else {
        this.$data.$_positionEditTargetTimelineSegmentEnd = lastSelectedTimelineSegment.end.clone();
      }
    },

    $_fixPositionEditTargetTimelineSegment() {
      let positionEditTargetTimelineData = this.visibleTimelineDataSet[this.$data.$_positionEditTargetTimelineSegmentId.timelineDataId];
      let positionEditTargetTimelineSegment = this.visibleTimelineDataSet.getSegment(this.$data.$_positionEditTargetTimelineSegmentId).clone();
      positionEditTargetTimelineSegment.assign({
        begin: this.$data.$_positionEditTargetTimelineSegmentBegin,
        end: this.$data.$_positionEditTargetTimelineSegmentEnd,
      })
      this.setSegment(
        this.$data.$_positionEditTargetTimelineSegmentId,
        positionEditTargetTimelineData.segmentDataType,
        positionEditTargetTimelineSegment,
        'Offset segment.',
        'Offsetting segment',
      );
      this.$data.$_positionEditTargetTimelineSegmentId = undefined;
      this.$data.$_positionEditTargetTimelineSegmentBegin = undefined;
      this.$data.$_positionEditTargetTimelineSegmentEnd = undefined;
    },

    $_isTimeInView(time) {
      if (time.isLessThan(this.$data.$_timelineViewBegin)) return false;
      if (time.isGreaterThanOrEqualTo(this.$_timelineViewEnd)) return false;
      return true;
    },

    $_emitUpdateIsLoopEnabled(isLoopEnabled) {
      this.$emit('update:is-loop-enabled', isLoopEnabled)
    },
  }
};
</script>